(function() {
  'use strict';

  angular
    .module('wedriveUsercenterWeb', ['ngCookies', 'ngMessages','ui.router', 'WASData', 'toaster','angular-popups']);

})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('UpdatePasswordController', UpdatePasswordController);

  function UpdatePasswordController(UserService,Toaster,$rootScope) {
    var vm = this;

    vm.params = {
      oldPassword : '',
      newPassword : ''
    };

    vm.updatePassword = function(valid){
      if(!valid) {
        return;
      }

      vm.updatePW_form.$submitted = true;

      UserService.updatePassword(vm.params).then(function(data){
        vm.updatePW_form.$submitted = false;
        Toaster.success('修改密码成功');
        $rootScope.$broadcast('user:logged_in',data.token);
        vm.params.oldPassword = '';
        vm.params.newPassword = '';

        //console.log(data)
      },function(err){
        vm.updatePW_form.$submitted = false;

        var msg =  '密码修改失败，请稍后再试！';

        switch(err.code) {
          case 1022:
            msg = '原密码错误';
            break;
        }

        Toaster.error(msg);

        //console.log(err)
      })
    }
  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('BindThirdPartyController', BindThirdPartyController);

  function BindThirdPartyController($scope,WeixinService,$window,UserService,Toaster) {

    var vm = this;

    var storage = '',
        email = '',
        mobile = '';

    vm.bindInfo = {};

    $scope.$watch('userInfo',function(val){
      var bi = val.bindInfo ? val.bindInfo.split(',') : [];

      vm.bindInfo = {};

      bi.forEach(function(item){

        if(item){
          vm.bindInfo[item] = true;
        }

      });

      email = val.email;
      mobile = val.mobile;
    });

    var jWindow = jQuery(window);

    vm.openBindQRCode = function(){
      storage = 'bwc_' + Date.now();

      $window.open(WeixinService.getBindQRCodeUrl(storage),'_blank');
      jWindow.off("storage");
      jWindow.on("storage",onStorageChange);

    };

    function onStorageChange(){
      if(storage && localStorage[storage]){
        location.reload();
      }
    }

    vm.unBind = function(type){

      if(!email && !mobile){
        Toaster.confirm('请先绑定手机或邮箱用于登录，再进行解绑',';;false');
      }else{
        Toaster.confirm('您确定要解除关联吗？',';解除关联',function(){

          UserService.unbindThridParty(type).then(function(){
            delete vm.bindInfo.weixin;
            Toaster.success('解除关联成功');
          },function(){
            Toaster.success('解除关联失败，请稍后再试');
          })

        });
      }


    }
  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('BindMobileController', BindMobileController);

  function BindMobileController(UserService,$rootScope,Toaster,$timeout,$q) {

    var vm = this;
    var paramsTpl = {
      type : '',
      oldMobile : '',
      oldSmsCode : '',
      newMobile : '',
      newSmsCode : ''
    };

    //vm.email = $rootScope.userInfo.email;
    //vm.params = angular.copy(paramsTpl);

    vm.dialog = {
      open : false,
      view : 0,
      next : function(valid){
        if(!valid){
          return;
        }

        if(vm.params.oldMobile !== $rootScope.userInfo.mobile){
          Toaster.error('该手机与当前绑定的手机不符');
          return;
        }

        vm.change_form.$submitted = true;

        UserService.checkChangeMobile({
          mobile : vm.params.oldMobile,
          smsCode : vm.params.oldSmsCode
        }).then(function(data){
          vm.change_form.$submitted = false;
          vm.dialog.view = 1;

        },function(err){
          vm.change_form.$submitted = false;
          Toaster.error(err.message);

        });

      },
      bind : function(valid){
        if(!valid){
          return;
        }

        if(vm.params.oldMobile === vm.params.newMobile){
          Toaster.error('当前手机和新手机相同，请修改');

          return;
        }

        vm.bind_form.$submitted = true;

        // TODO: 判断手机可用性
        UserService.vacantMobile(vm.params.newMobile).then(function(){

          var params = {
            mobile : vm.params.newMobile,
            smsCode : vm.params.newSmsCode,
            type : vm.params.type
          };

          if(params.type === 'changeBind'){
            params.oldMobile = vm.params.oldMobile;
            params.oldSmsCode = vm.params.oldSmsCode;

          }else if(params.type !== 'bind'){
            return;
          }

          // TODO: 绑定手机
          UserService.bindMobile(params).then(function(data){
            vm.bind_form.$submitted = false;

            Toaster.success('绑定成功');
            vm.dialog.open = false;
            $rootScope.userInfo.mobile = vm.params.newMobile;

          },function(err){
            vm.bind_form.$submitted = false;

            var msg = err.message;

            if(err.code === 1001){
              msg = '当前手机错误，请重试';
            }

            Toaster.error(msg);

          });

        },function(){
          vm.bind_form.$submitted = false;

          Toaster.error('该手机已绑定其它账号，请先解绑');

        });

      }

    };

    vm.openChange = function(){
      vm.params = angular.copy(paramsTpl);
      vm.params.type = 'changeBind';
      vm.dialog.open = true;
      vm.dialog.view = 0;
    };

    vm.openBind = function(){
      vm.params = angular.copy(paramsTpl);
      vm.params.type = 'bind';
      vm.dialog.open = true;
    };

    vm.changeBindSmsOptions = {
      service : UserService.applyBindMobile,
      beforeSend : function(){
        if(vm.params.oldMobile !== $rootScope.userInfo.mobile){
          $timeout(function(){
            Toaster.error('该手机与当前绑定的手机不符');
          });

          return false;
        }
      },
      name : 'oldMobile',
      params : {
        mobile : '$value',
        type : 'changeBind'
      }

    };

    vm.bindSmsOptions = {
      service : UserService.applyBindMobile,
      beforeSend : function(){
        var d = $q.defer();

        UserService.vacantMobile(vm.params.newMobile).then(function(){
          d.resolve();
        },function(){
          alertVacant();
        });

        return d.promise;
      },
      name : 'newMobile',
      params : {
        mobile : '$value',
        type : 'bind'
      }
    };

    vm.vacant = function(){
      if(vm.params.newMobile){
        UserService.vacantMobile(vm.params.newMobile).then(function(){
        },function(){
          alertVacant();
        });
      }
    };

    var vacantTimer = null;
    function alertVacant(){
      $timeout.cancel(vacantTimer);
      vacantTimer = $timeout(function(){
        Toaster.error('该手机已绑定其它账号，请先解绑');
      },100);
    }
  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('BindEmailController', BindEmailController);

  function BindEmailController(UserService,$rootScope,Toaster,$timeout,$q,$element) {
    var vm = this;
    var paramsTpl = {
      type : '',
      oldEmail : '',
      oldVcode : '',
      newEmail : '',
      newVcode : ''
    };

    //vm.email = $rootScope.userInfo.email;
    //vm.params = angular.copy(paramsTpl);

    vm.dialog = {
      open : false,
      view : 0,
      next : function(valid){
        if(!valid){
          return;
        }

        if(vm.params.oldEmail !== $rootScope.userInfo.email){
          Toaster.error('该邮箱与当前绑定的邮箱不符');
          return;
        }

        vm.change_form.$submitted = true;

        UserService.checkChangeEmail({
          email : vm.params.oldEmail,
          verifyCode : vm.params.oldVcode
        }).then(function(data){
          vm.change_form.$submitted = false;
          vm.dialog.view = 1;

        },function(err){
          vm.change_form.$submitted = false;
          Toaster.error(err.message);

        });

      },
      bind : function(valid){
        if(!valid){
          return;
        }

        if(vm.params.oldEmail === vm.params.newEmail){
          Toaster.error('当前邮箱和新邮箱相同，请修改');

          return;
        }

        vm.bind_form.$submitted = true;

        // TODO: 判断邮箱可用性
        UserService.vacantEmail(vm.params.newEmail).then(function(){

          var params = {
            email : vm.params.newEmail,
            verifyCode : vm.params.newVcode,
            type : vm.params.type
          };

          if(params.type === 'changeBind'){
            params.oldEmail = vm.params.oldEmail;
            params.oldVerifyCode = vm.params.oldVcode;

          }else if(params.type !== 'bind'){
            return;
          }

          // TODO: 绑定邮箱
          UserService.bindEmail(params).then(function(data){
            vm.bind_form.$submitted = false;

            Toaster.success('绑定成功');
            vm.dialog.open = false;
            $rootScope.userInfo.email = vm.params.newEmail;

          },function(err){
            vm.bind_form.$submitted = false;

            var msg = err.message;

            if(err.code === 1001){
              msg = '当前绑定邮箱错误，请重试';
            }

            Toaster.error(msg);

          });


        },function(){
          vm.bind_form.$submitted = false;

          Toaster.error('该邮箱已绑定其它账号，请先解绑');

        });

      }

    };

    vm.openChange = function(){
      vm.params = angular.copy(paramsTpl);
      vm.params.type = 'changeBind';
      vm.dialog.open = true;
      vm.dialog.view = 0;
    };

    vm.openBind = function(){
      vm.params = angular.copy(paramsTpl);
      vm.params.type = 'bind';
      vm.dialog.open = true;
    };

    vm.changeBindVcodeOptions = {
      service : UserService.applyBindEmail,
      beforeSend : function(){
        if(vm.params.oldEmail !== $rootScope.userInfo.email){
          $timeout(function(){
            Toaster.error('该邮箱与当前绑定的邮箱不符');
          });
          return false;
        }
      },
      name : 'oldEmail',
      params : {
        email : '$value',
        type : 'changeBind'
      }

    };

    vm.bindVcodeOptions = {
      service : UserService.applyBindEmail,
      beforeSend : function(){
        var d = $q.defer();

        UserService.vacantEmail(vm.params.newEmail).then(function(){
          d.resolve();
        },function(){
          alertVacant();
        });

        return d.promise
      },
      name : 'newEmail',
      params : {
        email : '$value',
        type : 'bind'
      }
    };

    vm.vacant = function(){
      if(vm.params.newEmail){
        UserService.vacantEmail(vm.params.newEmail).then(function(){},function(){
          alertVacant()
        });
      }
    };

    var vacantTimer = null;
    function alertVacant(){
      $timeout.cancel(vacantTimer);
      vacantTimer = $timeout(function(){
        Toaster.error('该邮箱已绑定其它账号，请先解绑');
      },100);
    }


  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('WeixinLoginController', WeixinLoginController);

  function WeixinLoginController($stateParams,UserService,$window,$rootScope,$state) {

    var vm = this;

    vm.code = $stateParams.code;
    vm.state = $stateParams.state; //redirect参数
    vm.error = '';

    UserService.weixinLogin($stateParams.code).then(function(data){
      //console.log(data);

      if(vm.state){
        $window.location.href = decodeURIComponent(vm.state);
      }else{
        $rootScope.$broadcast('user:logged_in', data.token);
        $state.go('home');
      }

    },function(data){
      vm.error = '微信登录失败，请稍后再试';

      //console.log(data);
    });

  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('WeixinBindController', WeixinBindController);

  function WeixinBindController($stateParams,UserService,$rootScope,$timeout) {

    var vm = this;

    vm.code = $stateParams.code;
    vm.state = $stateParams.state; //redirect参数
    vm.error = '';
    vm.success = '';

    $rootScope.$watch('userInfo.token',function(data){
      if(data){
        UserService.weixinBind($stateParams.code).then(function(){

          vm.success = '恭喜您，微信关联成功';

          localStorage[$stateParams.state] = 1;

          $timeout(function(){
            delete localStorage[$stateParams.state];
          },100);

        },function(data){

          if(data.code === 1036){
            vm.error = '此微信号已关联其他账号';
          }else{
            vm.error = '微信关联失败，请稍后再试';
          }

        });
      }
    });



  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('ActivateEmailController', ActivateEmailController);

  function ActivateEmailController(UserService,$location,$state,Toaster,$rootScope) {

    var vm = this;
    vm.failed = false;

    UserService.activeEmail($location.$$search.q).then(function(data){
      //console.log(data)
      //$rootScope.$broadcast('user:logged_in',data.token);
      //Toaster.success('邮箱激活成功，快去完善资料吧！');
      Toaster.success('邮箱激活成功！请登录。');
      $state.go('noAccess.login','',{
        location : 'replace',redirect:$rootScope.redirectUrl
      });

    },function(err){

      vm.failed = true;
      vm.message = err.message && '，' + err.message;

      //Toaster.error('邮箱激活失败！');
      //$state.go('noAccess.login');
    })

  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('PhotoController', PhotoController);

  function PhotoController($scope,Toaster,UserService,$element) {
    var vm = this;

    vm.photo = UserService.getUserPhoto();
    vm.file = null;
    vm.submitted = false;

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");
    var canvasOverlay = $element.find('#canvasOverlay'); //取景框
    var imageType = ''; //选中文件的imageType
    var min = 100; //取景框最小宽度
    var $document = $(document);
    $(canvas).appendTo('#canvasContent');

    //拖拽取景框
    drag(canvasOverlay);

    /**
     * 选择文件
     * */
    vm.pickPhoto = function() {
      $fileInput = $('<input type="file" accept="image/*">');

      $fileInput.on('change',function(){
        var reader = new FileReader();
        var file = this.files[0];
        imageType = file.type;

        //console.log(file);
        reader.readAsDataURL(file);
        reader.onload = function () {

          //压缩图片
          compressImg(this.result,function(img){

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0, img.width, img.height);

            reloadOverlay(img.width,img.height);

            croppingPhoto();

          });
        };
      });

      $fileInput.trigger('click');

    };

    /**
     * 压缩图片
     * */
    function compressImg(imgData,onCompress){

      if(!imgData)return;

      onCompress = onCompress || function(){};

      var maxPx = 350;
      var img = new Image();

      var longSide = '',
          shortSide = '';

      var longPx = 0,
          shortPx = 0;

      img.onload = function(){

        longSide = img.height > img.width ? 'height' : 'width';
        shortSide = img.height > img.width ? 'width' : 'height';

        longPx = maxPx;
        shortPx = longPx * img[shortSide] / img[longSide];

        img[longSide] = longPx;
        img[shortSide] = shortPx;

        //onCompress(canvas.toDataURL("image/jpeg"));//必须等压缩完才读取canvas值，否则canvas内容是黑帆布
        onCompress(img);

      };

      img.src = imgData;

    }

    /**
     * 重载取景框
     * */
    function reloadOverlay(width,height){

      var longPx = Math.max(width,height);
      var shortPx  = Math.min(width,height);

      var left = 0,
          top = 0,
          middle = (longPx - shortPx) / 2;

      if(width > height){
        left = middle;
      }else{
        top = middle;
      }

      canvasOverlay.css({
        width : shortPx,
        height : shortPx,
        left : left,
        top : top
      });

      resizeMask(shortPx,top,left,width,height);
    }

    /**
     * 上传图片
     * */
    vm.upLoadPhoto = function(){

      vm.submitted = true;
      UserService.uploadPhoto(vm.file).then(function(){
        vm.submitted = false;
        Toaster.success('头像上传成功');
        vm.file = null;

      },function(err){
        vm.submitted = false;
        Toaster.error(err.message || '头像上传失败');

      });

    };

    /**
     * 清除图片
     * */
    vm.cleanPhoto = function(){
      vm.photo = UserService.getUserPhoto();
      vm.file = null;
    };

    /**
     * 裁剪图片
     * */
    croppingPhoto = function(){

      var crop_canvas = document.createElement('canvas'),
          left = Math.round(parseFloat(canvasOverlay.css('left'))),
          top =  Math.round(parseFloat(canvasOverlay.css('top'))),
          width = canvasOverlay.width(),
          height = canvasOverlay.height();

      var img = new Image();

      crop_canvas = document.createElement('canvas');
      crop_canvas.width = width;
      crop_canvas.height = height;

      img.onload = function(){
        crop_canvas.getContext('2d').drawImage(img, left, top, width, height, 0, 0, width, height);
        var base64 = crop_canvas.toDataURL(imageType);
        vm.photo = base64;

        var byteCharacters = atob(base64.replace( /.* ?,/, ''));
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0, len = byteCharacters.length; i < len; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        vm.file = new Blob([(new Uint8Array(byteNumbers)).buffer], {type : base64.match(/data:(.*?);/)[1]});

        crop_canvas = null;
        img.onload = null;
        img = null;

        $scope.$digest();

      };

      img.src = canvas.toDataURL(imageType);

    };

    /**
     * 拖拽 : 绑定mouseDown事件
     * */
    function drag(item){
      item.on('mousedown',downFn);
    }

    /**
     * 拖拽 : 鼠标按下
     * */
    function downFn(e){
      var oEvent = e.originalEvent;

      var item = oEvent.srcElement || oEvent.target,
          src = this,
          disY,disX,downY,downX,oldH,oldW,oldT,oldL;

      var wrap = canvas;

      var role = item.getAttribute('role') || '';


      if(role){
        /** 鼠标按下的元素是四个角: 调整大小 **/

        if(role.indexOf('b')!=-1){
          downY=oEvent.clientY;
          oldH=src.offsetHeight;
        }

        if(role.indexOf('r')!=-1){
          downX=oEvent.clientX;
          oldW=src.offsetWidth;
        }

        if(role.indexOf('t')!=-1){
          downY=oEvent.clientY;
          oldH=src.offsetHeight;
          oldT=src.offsetTop;
        }

        if(role.indexOf('l')!=-1){
          downX=oEvent.clientX;
          oldW=src.offsetWidth;
          oldL=src.offsetLeft;
        }

        $document
          .on('mousemove',{
            downY : downY,
            downX : downX,
            oldH : oldH,
            oldW : oldW,
            oldT : oldT,
            oldL : oldL,
            role : role,
            wrapH: wrap.offsetHeight,
            wrapW: wrap.offsetWidth,
            item : src
          },resizeFn)

      }else{
        /** 鼠标按下的元素是不是四个角: 移动 **/

        disY=oEvent.clientY-item.offsetTop;
        disX=oEvent.clientX-item.offsetLeft;

        $document
          .on('mousemove',{
            disY:disY,
            disX:disX,
            item:src,
            itemH:item.offsetHeight,
            itemW:item.offsetWidth,
            wrapH:wrap.offsetHeight,
            wrapW:wrap.offsetWidth
          },moveFn)
      }

      $document
        .on('mouseup',{
          item:item
        },upFn);

      item.setCapture && item.setCapture();

      return false;
    }

    /**
     * 拖拽 : 调整大小
     * */
    function resizeFn(e){
      var data = e.data;
      var oEvent =  e.originalEvent;

      var role = data.role,
          downY = data.downY,
          downX = data.downX,
          oldH = data.oldH,
          oldW = data.oldW,
          oldT = data.oldT,
          oldL = data.oldL,
          clientH = data.wrapH,
          clientW = data.wrapW,
          oDiv = data.item;

      var targetY,targetX,newH,newW,newL,newT,width;

      var _left = parseInt(oDiv.style.left),
          _top = parseInt(oDiv.style.top),
          xRight,xBottom;


      /** 获得鼠标的偏移 **/
      if(role.indexOf('b')!=-1){
        targetY = oEvent.clientY - downY;
        newH = oldH + targetY;
      }
      if(role.indexOf('r')!=-1){
        targetX = oEvent.clientX - downX;
        newW = oldW + targetX;
      }
      if(role.indexOf('t')!=-1){
        targetY = oEvent.clientY - downY;
        newH = oldH - targetY;
      }
      if(role.indexOf('l')!=-1){
        targetX = oEvent.clientX - downX;
        newW = oldW - targetX;
      }

      width = Math.max(newW,newH,min);

      /** 计算取景框的大小和位置 **/

      //左上角
      if(role.indexOf('tl')!=-1){

        xBottom = clientH - oldT - oldH;
        xRight = clientW - oldL - oldW;
        width = Math.min(clientH - xBottom,clientW - xRight,width);

        newT = oldT + oldH - width;
        newL = clientW - xRight - width;

        oDiv.style.left = newL + 'px';
        oDiv.style.top = newT + 'px';

      }

      //右上角
      if(role.indexOf('tr')!=-1){

        xBottom = clientH - oldT - oldH;
        width = Math.min(clientW - _left,clientH - xBottom,width);
        newT = oldT + oldH - width;
        oDiv.style.top = newT + 'px';

      }

      //左下角
      if(role.indexOf('bl')!=-1){

        xRight = clientW - oldL - oldW;
        width = Math.min(clientW - xRight,clientH - _top,width);
        newL = clientW - xRight - width;
        oDiv.style.left = newL + 'px';

      }

      //右下角
      if(role.indexOf('br')!=-1){

        if(width + _left > clientW || width + _top > clientH) width = Math.min(clientW - _left,clientH - _top);

      }

      oDiv.style.width = width+ 'px';
      oDiv.style.height = width+ 'px';

      resizeMask(width,parseInt(oDiv.style.top),parseInt(oDiv.style.left),clientW,clientH)
    }

    /**
     * 拖拽 : 移动
     * */
    function moveFn(e){
      var data = e.data;
      var oEvent =  e.originalEvent;

      var t = oEvent.clientY - data.disY;
      var l = oEvent.clientX - data.disX;

      if(t < 0) t=0;
      if(l < 0) l=0;

      if(t > data.wrapH - data.itemH) t =  data.wrapH - data.itemH;
      if(l > data.wrapW - data.itemW) l =  data.wrapW - data.itemW;

      data.item.style.top = t +'px';
      data.item.style.left = l +'px';

      resizeMask(data.itemW,t,l,data.wrapW,data.wrapH);
    }

    /**
     * 拖拽 : 鼠标松开
     * */
    function upFn(e){
      var item = e.data.item;
      croppingPhoto();
      $document.off('mousemove',moveFn).off('mousemove',resizeFn).off('mouseup',upFn);
      item.releaseCapture && item.releaseCapture();
    }

    /**
     * 取景框遮罩
     * */
    var maskN = $element.find('#maskN'),
        maskS = $element.find('#maskS'),
        maskE = $element.find('#maskE'),
        maskW = $element.find('#maskW');

    /**
     * 计算遮罩位置和大小
     * w : 内容width/height,
     * t : 内容top,
     * l : 内容left,
     * W : 容器width,
     * H : 容器height
     *                               覆盖在canvas上
     *                                    /
     * * * * * * * * * W * * * * * * * * /
     * --------------------------------- *
     * |         |           |         | *
     * |         t   maskN   |         | *
     * |         |           |         | *
     * |* * l * *|-----w-----|         | *
     * |         |           |         | *
     * |  maskW  w    view   |  maskE  | H
     * |         |           |         | *
     * |         |-----------|* * r * *| *
     * |         |           |         | *
     * |         b   maskS   |         | *
     * |         |           |         | *
     * --------------------------------- *
     *
     * view : 取景框
     *
     * */
    function resizeMask(w,t,l,W,H){

      var r = W - l - w, //内容right
          b = H - t - w; //内容bottom

      maskN.css({
        width : w + 'px',
        height : t + 'px',
        left : l + 'px'
      });

      maskS.css({
        width : w + 'px',
        height : b + 'px',
        left : l + 'px'
      });

      maskW.css({
        width : l + 'px',
        height : H + 'px'
      });

      maskE.css({
        width : r + 'px',
        height : H + 'px'
      })
    }
  }

})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('NicknameController', NicknameController);

  function NicknameController($rootScope,Toaster,UserService) {

    var vm = this;
    vm.nickname = '';

    vm.updateNickname = function(valid){
      console.log(valid,vm.nickname,$rootScope.userInfo.nickEditable);

      if(!valid){
        //vm.nickname_form.$submitted = false;
        return;
      }

      if(angular.copy(vm.nickname).replace(/[\u4e00-\u9fa5]/g,"aa").length > 14){
        Toaster.error('最长14个字节,一个汉字等于两字节');
        return;
      }

      if($rootScope.userInfo.nickEditable !== 1){
        Toaster.error('昵称已经修改过,不能再次修改!');
        return;
      }

      vm.nickname_form.$submitted = true;

      UserService.updateUserInfo({
        nickname : vm.nickname
      }).then(function(data){
        vm.nickname_form.$submitted = false;
        $rootScope.userInfo.nickEditable = 0;
        Toaster.success('设置昵称成功!');

        //console.log(data);

      },function(err){
        vm.nickname_form.$submitted = false;
        Toaster.error('设置昵称失败,请稍后再试!');

        //console.log(err)
      })

    }


  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('CarController', CarController)
    .filter('carModelFilter',carModelFilter)
    .filter('dateFilter',_dateFilter);

  function CarController(UserService,$rootScope,$scope,$timeout,Toaster) {

    var vm = this;

    /**** 添加/编辑dialog ****/
    vm.dialog = {
      type : 'add',
      status : 0,
      open : false
    };

    /**** 车辆数据的空白模板 ****/
    var aCarTpl = {
      id : '',        //carId
      carModel : '',  //carModelId
      date : '',      //carBuyDate
      engine : '',    //engineNo
      vin : '',    //engineNo
      licence : '',   //province + licence = lisenceNo
      icon : '',      //carIcon
      carModelValid : false,
      carModelshowBubble : false,
      dateValid : true,
      province : ''

    };

    //vm.aCar = undefined;

    /**** 显示我的爱车 ****/
    vm.myCar = $rootScope.userInfo.carInfo || [];

    $scope.$watch('userInfo.carInfo',function(data){
      vm.myCar = data || vm.myCar;
    });

    /**** 添加我的爱车 ****/
    vm.addCar = function(){
      refreshDialog('add');
    };

    vm.submitDialog = function (valid){
      var car = vm.aCar;

      if(!car.carModelValid){
        car.carModelshowBubble = true;
        return;
      }

      if(!valid){
        return
      }

      if(!car.dateValid){
        return
      }

      var params = {
        carModelId : car.carModel,
        carIcon : car.icon
      };

      //if(car.licence) params.lisenceNo = car.province + car.licence;
      //if(car.engine) params.engineNo = car.engine;
      //if(car.date) params.carBuyDate = car.date;
      params.lisenceNo = car.licence ?  car.province + car.licence : '';
      params.engineNo = car.engine;
      params.vin = car.vin;
      params.carBuyDate = car.date;
      if(car.id) params.carId = car.id;

      vm.edit_form.$submitted = true;

      UserService.addCar(params).then(function(data){

        vm.edit_form.$submitted = false;

        if(params.carId){
          // 修改车辆
          Toaster.success('修改成功');

          for(var i= 0,c;c=vm.myCar[i];i++){
            if(c.carId === params.carId){
              vm.myCar.splice(i,1,params);
              break;
            }
          }

        }else{
          // 添加车辆
          Toaster.success('添加成功');
          params.carId = data.carId;
          vm.myCar.push(params);
        }

        vm.dialog.open = false;

      },function(err){
        vm.edit_form.$submitted = false;
        var msg = '';

        if(err.code === 1034){
          msg = '车牌号已存在'
        }

        Toaster.error(msg || err.message);
      })

    };

    /**** 编辑我的爱车 ****/
    vm.editCar = function(id){
      refreshDialog('edit',id);
    };

    /**** 删除我的爱车 ****/

    vm.removeCar = function(id){

      vm.dialogRemoveCar.id = id;
      vm.dialogRemoveCar.open = true;
      vm.dialogRemoveCar.content = getCarInfo(id).carModelId;

    };

    vm.dialogRemoveCar = {
      open: false,
      id: '',
      $submitted : false,
      ok: function () {
        var that = this;
        var id = this.id;

        that.$submitted = true;
        UserService.removeCar(id).then(function(){
          that.$submitted = false;

          for(var i= 0,c;c=vm.myCar[i];i++){
            if(c.carId === that.id){
              vm.myCar.splice(i,1);
              break;
            }
          }

          that.open = false;
          Toaster.success('删除成功');

        },function(err){
          that.$submitted = false;
          Toaster.error(err.message);
        })
      },
      content: ''
    };

    function getCarInfo(id){
      for(var i = 0,c; c = vm.myCar[i]; i++){
        if(c.carId === id){
          return c;
        }
      }

      return {};
    }

    function refreshDialog(type,id){

      vm.dialog.type = type;
      vm.dialog.status = 0;
      vm.aCar = id ? carInfo2carModel(id) : angular.copy(aCarTpl);

      vm.dialog.open = true;

    }

    function carInfo2carModel(id){
      var info = getCarInfo(id);

      var model = {
        id : id,
        carModel : info.carModelId,
        date : dateFilter(info.carBuyDate),
        engine : info.engineNo,
        vin : info.vin,
        icon : info.carIcon
      };

      if(info.lisenceNo){
        model.province = info.lisenceNo.charAt(0);
        model.licence = info.lisenceNo.substring(1);
      }

      return angular.extend({},aCarTpl,model);

    }

  }

  function carModelFilter(){
    return function(val){
      return JSON.parse(val).join(',');
    }
  }

  function toDouble(n){
    return n < 10 ? '0' + n : '' + n;
  }

  function dateFilter(val){
    if(val){
      var date = new Date(val);
      return date.getFullYear() + '-' + toDouble(date.getMonth() + 1) + '-' + toDouble(date.getDate());
    }else{
      return '';
    }
  }

  function _dateFilter(){
    return dateFilter;
  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('BasicInfoController', BasicInfoController);

  function BasicInfoController($scope,UserService,Toaster,$rootScope) {
    var vm = this;
    vm.options = {};
    vm.birthdayValid = false;
    vm.regionValid = false;

    //vm.options = {
    //  gender : $rootScope.userInfo.gender,
    //  birthday : $rootScope.userInfo.birthday,
    //  liveProvince : $rootScope.userInfo.liveProvince,
    //  liveCity : $rootScope.userInfo.liveCity,
    //  liveDistrict : $rootScope.userInfo.liveDistrict
    //};
    vm.options = angular.copy($rootScope.userInfo);

    $scope.$watch('userInfo',function(){
      vm.options = angular.copy($rootScope.userInfo);
    });

    vm.updateUserInfo = function(){

      var params = {};
      var changed = false;

      if(vm.options.gender == 1 || vm.options.gender == 0){
        params.gender = vm.options.gender;
        changed = true;
      }

      if(vm.birthdayValid){

        params.birthday = vm.options.birthday;
        changed = true;
      }

      if(vm.regionValid){

        params.liveProvince = vm.options.liveProvince;
        params.liveCity = vm.options.liveCity;
        params.liveDistrict = vm.options.liveDistrict;
        changed = true;
      }

      //console.log(vm.options,params);

      if(changed){
        vm.info_form.$submitted = true;

        UserService.updateUserInfo(params).then(function(data){
          vm.info_form.$submitted = false;

          Toaster.success('资料修改成功');

          console.log(data);
        },function(err){
          vm.info_form.$submitted = false;

          Toaster.error('资料修改失败,请稍后再试');
          console.log(err);
        })
      }else{
        Toaster.error('没有可保存的内容,请先填写资料!');
      }

    };


  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('RegisterMController', RegisterMController);

  function RegisterMController($window,$rootScope,UserService,Toaster,$state,$timeout,$stateParams) {
    $rootScope.redirectUrl = $stateParams.redirect || null;

    var vm = this;
    vm.view = 0;

    vm.model = {
      mobile : '',
      captcha : '',
      password : '',
      smsCode : ''
    };

    /**
     * 注册步骤:
     *
     * 1.根据手机号获取图片验证码
     * 2.判断手机号是否可用
     * 3.验证图片验证码
     * 4.发送短信
     * 5.注册
     *
     * */

    /************ 第一页 *************/
    vm.captchaUrl = '';
    vm.validMobile = false;

    function getCaptcha() {
      return UserService.getCaptcha({
        identifier : vm.model.mobile,
        type : 'register'
      });
    }
    vm.getCaptcha = getCaptcha;

    vm.next = function(valid){
      vm.next_form.$submitted = true;

      if(!valid){
        vm.next_form.$submitted = false;

        //没填完表格,但是填了手机号,验证手机号是否被注册,但是不进行下一步
        if(vm.validMobile){
          vacantMobile(false)
        }
        return;
      }

      //已填完表格,验证手机号是否被注册,并进行下一步
      vacantMobile(true);

    };

    // bNext : 是否进行下一步
    function vacantMobile(bNext){

      UserService.vacantMobile(vm.model.mobile).then(function(data){
        vm.next_form.$submitted = false;
        bNext && checkCaptcha();
        //bNext && sendRegister();

      },function(data){
        vm.next_form.$submitted = false;

        if(data.code === 1006){
          alertVacant();
        }else{
          bNext && checkCaptcha();
          //bNext && sendRegister()
        }

      })
    }

    function checkCaptcha(){
      vm.next_form.$submitted = true;

      UserService.checkCaptcha({
        verifyCode : vm.model.captcha,
        identifier : vm.model.mobile,
        type : 'register'
      }).then(function(data){
        vm.next_form.$submitted = false;

        //切换到第二页
        vm.smsCodeOptions = {
          service : UserService.sendSms,
          params : {
            captcha : vm.model.captcha,
            //captcha : '',
            mobile : vm.model.mobile,
            type : 'resentRegister'
          },
          autoCD : 1
        };
        vm.view = 1;
        sendRegister();

      },function(err){
        vm.next_form.$submitted = false;

        if(err.code === 1011){
          vm.captchaUrl = getCaptcha();
        }


        Toaster.error(err.message);

      })
    }

    /************ 第二页 *************/
    vm.smsCodeSent = false;

    function sendRegister(){
      var params = {
        //captcha : '',
        captcha : vm.model.captcha,
        mobile : vm.model.mobile,
        type : 'register'

      };

      UserService.sendSms(params).then(function(data){
        vm.smsCodeSent = true;

      },function(err){

        Toaster.error(err.message);

      });
    }

    vm.register = function(){
      vm.register_form.$submitted = true;

      UserService.register({
        mobile : vm.model.mobile,
        password : vm.model.password,
        smsCode : vm.model.smsCode
      }).then(function(){
        login();

      },function(err){
        vm.register_form.$submitted = false;

        Toaster.error(err.message)

      })

    };

    function login(){
      UserService.login({
        loginName : vm.model.mobile,
        password : vm.model.password
      }).then(function(data){

        if($rootScope.redirectUrl){
          $window.location.href = decodeURIComponent($rootScope.redirectUrl);
        } else {
          $rootScope.$broadcast('user:logged_in',data.token);
          Toaster.success('恭喜您注册成功，快去完善资料吧！');
          $state.go('home');
        }
      }, function(){
        Toaster.success('恭喜您注册成功');
        $state.go('login');
      });
    }

    vm.vacant = function(){
      if(vm.model.mobile){
        UserService.vacantMobile(vm.model.mobile).then(function(){},function(data){
          if(data.code === 1006){
            alertVacant()
          }
        });
      }
    };

    var vacantTimer = null;
    function alertVacant(){
      $timeout.cancel(vacantTimer);
      vacantTimer = $timeout(function(){
        Toaster.confirm('该手机已被注册，您可以手机快捷登录！','提示;手机快捷登录',function(){
          $state.go('noAccess.login',{account:vm.model.mobile,quickLogin:1,redirect:$rootScope.redirectUrl})
        })
      },100);
    }

  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('RegisterEController', RegisterEController);

  function RegisterEController($scope,$rootScope,UserService,Toaster,$state,$timeout,$stateParams, $window) {
    $rootScope.redirectUrl = $stateParams.redirect || null;

    var vm = this;

    vm.view = 0;

    vm.model = {
      email : '',
      captcha : '',
      password : '',
      smsCode : ''
    };

    /**
     * 邮箱注册交互步骤:
     *
     * 1.根据邮箱地址获取图片验证码
     * 2.判断邮箱是否可用
     * 3.注册
     * 4.重发邮件(可选)
     *
     * */

    /************ 第一页 *************/
    vm.captchaUrl = '';
    vm.validEmail = false;

    function getCaptcha() {
      return UserService.getCaptcha({
        identifier : vm.model.email,
        type : 'register'
      });
    }
    vm.getCaptcha = getCaptcha;

    vm.next = function(valid){
      vm.next_form.$submitted = true;

      if(!valid){
        vm.next_form.$submitted = false;

        //没填完表格,但是填了邮箱,验证手机号是否被注册,但是不进行下一步
        if(vm.validEmail){
          vacantEmail(false)
        }
        return;
      }

      //已填完表格,验证邮箱是否被注册,并进行下一步
      vacantEmail(true);

    };

    // bNext : 是否进行下一步
    function vacantEmail(bNext){

      //console.log(vm.model.email)

      UserService.vacantEmail(vm.model.email).then(function(data){
        vm.next_form.$submitted = false;
        bNext && sendRegister();


      },function(data){
        vm.next_form.$submitted = false;

        if(data.code === 1008){
          alertVacant()
        }else{
          bNext && sendRegister();
        }

      })
    }

    /************ 第二页 *************/

    // 收件邮箱网页地址 如 http://mail.163.com
    vm.emailURL = '';

    // 激活地址
    var location = window.location;
    var origin = location.origin ? location.origin : location.protocol + '//' + location.hostname + (location.port ? ':'+ location.port : '');
    var activeURL = origin + '/' + location.pathname.substring(1) + '#/activateEmail';

    //console.log(activeURL);

    function sendRegister(){
      var params = {
        captcha : vm.model.captcha,
        email : vm.model.email,
        password : vm.model.password,
        redirectUrl : activeURL
      };

      UserService.registerByEmail(params).then(function(data){
        //vm.smsCodeSent = true;
        vm.view = 1;
        vm.emailURL = 'http://mail.' + vm.model.email.split('@')[1];

        vm.verifyCodeOptions = {
          service : UserService.sendEmail,
          params : {
            captcha : vm.model.captcha,
            email : vm.model.email,
            redirectUrl : activeURL,
            type : 'resentRegister'
          },
          autoCD : 1
        };

      },function(err){

        Toaster.error(err.message);

        if(err.code === 1011){
          vm.captchaUrl = getCaptcha()
        }

      });
    }

    vm.register = function(){
      vm.register_form.$submitted = true;

      UserService.register({
        mobile : vm.model.mobile,
        password : vm.model.password,
        smsCode : vm.model.smsCode
      }).then(function(data){
        if($rootScope.redirectUrl){
          $window.location.href = decodeURIComponent($rootScope.redirectUrl);
        } else {
          $rootScope.$broadcast('user:logged_in', data.token);
          Toaster.success('恭喜您注册成功，快去完善资料吧！');
          $state.go('home');
        }
      },function(err){
        vm.register_form.$submitted = false;

        Toaster.error(err.message)

      })

    };

    vm.vacant = function(){
      if(vm.model.email){
        UserService.vacantEmail(vm.model.email).then(function(){},function(data){
          if(data.code === 1008){
            alertVacant()
          }
        });
      }
    };

    var vacantTimer = null;
    function alertVacant(){
      $timeout.cancel(vacantTimer);
      vacantTimer = $timeout(function(){
        Toaster.confirm('该邮箱已被注册，您可以直接登录！','提示;去登录',function(){
          $state.go('noAccess.login',{account:vm.model.email,redirect:$rootScope.redirectUrl})
        })
      },100);
    }

  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('LoginController', LoginController);

  function LoginController($scope, $element, $timeout, UserService, $rootScope, $state, Toaster,$stateParams,$window,WeixinService) {
    $rootScope.redirectUrl = $stateParams.redirect || null;

    var vm = this;
    var Storage = window.localStorage || {};
    var redirectUrl = $rootScope.redirectUrl;

    /*** 两种登录方式切换 ***/
    vm.loginType = 0;
    $scope.$watch('login.loginType',function(type){
      $timeout(function(){
        var name = 'loginName';

        if(type === 1){
          name = vm.paramsQuick.mobile ? 'loginSmsCode' : 'loginMobile';
        }else{
          name = vm.paramsNormal.loginName ? 'password' : 'loginName';
        }

        $element.find('input[name='+ name +']').eq(0).focus();
      })
    });

    /*** 普通登录方式 ***/
    vm.paramsNormal = {
      loginName : '',
      autoLogin : Storage._wd_autoLogin === 'true',
      captcha : ''
    };
    vm.requiredCaptha = false;
    vm.login_form = {};

    if(!$stateParams.quickLogin){
      vm.paramsNormal.loginName = $stateParams.account;
    }

    //获取图片验证码
    vm._getCaptcha = function(){
      return UserService.getCaptcha({
        identifier : vm.paramsNormal.loginName,
        type : 'login'
      });
    };

    vm.getCaptcha = getCaptcha;
    vm.captchaUrl = '';

    function getCaptcha() {
      if(vm.loginType === 1) return;

      vm.captchaUrl = vm._getCaptcha();
    }


    function loginSuccess(userInfo){
      vm.login_form.$submitted = false;
      vm.quickLogin_form.$submitted = false;
      //Toaster.success('登录成功');
      Storage._wd_autoLogin = vm.loginType ? vm.paramsQuick.autoLogin : vm.paramsNormal.autoLogin;

      if(redirectUrl){
        $window.location.href = decodeURIComponent(redirectUrl);
      }else{
        $rootScope.$broadcast('user:logged_in', userInfo);
        $state.go('home');
      }
    }

    function loginError(data){
      vm.login_form.$submitted = false;
      vm.quickLogin_form.$submitted = false;

      var msg = '登录失败，请稍后再试！';

      switch(data.code) {
        case 1017:
          msg = false;
          getCaptcha();
          vm.requiredCaptha = true;
          break;

        case 1014:
          msg = '验证码已过期';
          getCaptcha();
          break;

        case 1011:
          msg = '验证码错误';
          getCaptcha();
          vm.requiredCaptha = true;
          break;

        case 1003:
          msg = '短信验证码错误';
          break;

        case 1021:
          msg = '账号或密码错误';
          vm.requiredCaptha && getCaptcha();
          break;
      }

      msg && Toaster.error(msg)
    }

    vm.submitNormal = function (valid) {
      if(!valid){
        vm.login_form.$submitted = false;
        return;
      }
      vm.login_form.$submitted = true;
      UserService.login(vm.paramsNormal).then(loginSuccess, loginError);
    };

    /*** 手机快捷登录 ***/

    vm.paramsQuick = {
      autoLogin : Storage._wd_autoLogin === 'true'
    };
    vm.smsCodeOptions = {
      name : 'loginMobile',
      params : {
        mobile : '$value',
        type : 'quickLogin'
      },
      service : UserService.sendSms
    };

    if($stateParams.quickLogin){
      vm.paramsQuick.mobile = $stateParams.account;
      vm.loginType = 1;
    }

    vm.submitQuick = function(valid){
      vm.quickLogin_form.$submitted = true;

      if(!valid){
        vm.quickLogin_form.$submitted = false;
        return;
      }

      UserService.quickLogin(vm.paramsQuick).then(loginSuccess, loginError)
    };

    vm.sendSms = function(){

      UserService.sendSms({
        mobile : vm.paramsQuick.mobile,
        type : 'quickLogin'
      }).then(function(data){console.log(data)},function(data){console.log(data)})

    };

    vm.weixinLoginQRCodeUrl = WeixinService.getLoginQRCodeUrl(redirectUrl);

  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('FindPasswordController', FindPasswordController);

  function FindPasswordController(UserService,$scope,$rootScope, Toaster,$state) {

    var vm = this;
    vm.view = 0;

    /*********** 第一步:验证账号(并发送验证码) ***********/
    vm.paramsAccount = {
      account : '',
      captcha : '',
      type : ''
    };

    vm.captchaUrl = '';

    function getCaptcha() {
      return UserService.getCaptcha({
        identifier : vm.paramsAccount.account,
        type : 'findPassword'
      });
    }
    vm.getCaptcha = getCaptcha;


    vm.checkAccount = function(valid){

      if(!valid){
        return;
      }

      vm.account_form.$submitted = true;
      vm.paramsAccount.type = computedAccount(vm.paramsAccount.account);

      UserService.findPassword.checkAccount(vm.paramsAccount).then(function(data){
        vm.account_form.$submitted = false;

        vm.vcodeOptions = {
          service : UserService.findPassword.reSendVerifyCode,
          params : vm.paramsAccount,
          autoCD : 1
        };

        vm.view = 1;
        //console.log(data)
      },function(err){
        vm.account_form.$submitted = false;

        var msg = err.message;
        if(err.code === 1007 || err.code === 1009){
          msg = '账号不存在'
        }

        if(err.code === 1011){
          vm.captchaUrl = getCaptcha();
        }

        Toaster.error(msg);
      })
    };

    function computedAccount (account){
      var regMobile = /^1\d{10}$/;
      var regEmail = /^([a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+)$/i;

      if(regMobile.test(account)){
        return 'mobile'
      }else if(regEmail.test(account)){
        return 'email'
      }else{
        return ''
      }
    }


    /*********** 第二步:验证验证码(可重发验证码) ***********/

    vm.verifyCode = '';

    vm.checkVerifyCode = function(valid){
      if(!valid){
        //vm.check_form.$submitted = false;
        return;
      }

      vm.check_form.$submitted = true;

      UserService.findPassword.checkVerifyCode({
        account : vm.paramsAccount.account,
        verifyCode : vm.verifyCode,
        type : vm.paramsAccount.type
      }).then(function(data){
        vm.check_form.$submitted = false;
        vm.view = 2;
        //console.log(data)
      },function(err){
        vm.check_form.$submitted = false;
        Toaster.error(err.message);
        //console.log(err)
      })

    };

    /*********** 第三步:重置密码 ***********/

    vm.newPassword = '';

    vm.resetPassword = function(valid){
      if(!valid){
        //vm.reset_form.$submitted = false;
        return;
      }
      vm.reset_form.$submitted = true;

      UserService.findPassword.resetPassword({
        account : vm.paramsAccount.account,
        verifyCode : vm.verifyCode,
        newPassword : vm.newPassword
      }).then(function(data){
        vm.reset_form.$submitted = false;

        Toaster.success('恭喜您设置密码成功！');
        $state.go('noAccess.login',{account:vm.paramsAccount.account,redirect:$rootScope.redirectUrl});
        //console.log(data)

      },function(err){
        vm.reset_form.$submitted = false;
        Toaster.error(err.message);
        //console.log(err)
      });
    }

  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('SecurityController', ['$scope', '$rootScope', SecurityController]);

  function SecurityController() {
    this.sidebar = [
      {
        href : 'security.updatePassword',
        ico : 'ico-password2',
        title : '修改密码'
      },
      {
        href : 'security.bindMobile',
        ico : 'ico-mobile2',
        title : '绑定手机'
      },
      {
        href : 'security.bindEmail',
        ico : 'ico-email2',
        title : '绑定邮箱'
      },
      // {
      //   href : 'security.bindThirdParty',
      //   ico : 'ico-bind2',
      //   title : '账号关联'
      // }
    ];
  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('ProfileController', ['$scope', '$rootScope', ProfileController]);

  function ProfileController($rootScope) {

    var vm = this;

    vm.sidebar = [
      {
        href : 'profile.photo',
        ico : 'ico-photo2',
        title : '我的头像'
      },
      {
        href : 'profile.basicInfo',
        ico : 'ico-info2',
        title : '基本资料'
      },
      {
        href : 'profile.car',
        ico : 'ico-car2',
        title : '我的爱车'
      },
      {
        href : 'profile.nickname',
        ico : 'ico-nickname2',
        title : '我的昵称',
        hide : true
      }
    ];

    $rootScope.$watch('userInfo.nickEditable',function(nickname){
      vm.sidebar[3].hide = !nickname;
    });

  }
})();

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .controller('HomeController', HomeController);

  function HomeController(UserService,Toaster,$rootScope,$state) {
    var vm = this;

    $rootScope.$watch('userInfo.token',function(token){
      if(token){
        vm.userPhotoUrl = UserService.getUserPhoto();
      }
    });

    $rootScope.$watch('userInfo.userId',function(id){
      if(id){
        UserService.loginHistory(id).then(function(data){
          vm.loginHistory.data = data.length ? data : null;
        });
      }
    });

    //vm.loginHistory = {
    //  data : [
    //    {
    //      "loginTime": "2016-02-24 15:43:57",
    //      "ip": "10.10.101.81",
    //      "city": null,
    //      "device": "web"
    //    }
    //  ],
    //  more : false
    //};

    vm.loginHistory = {
      data : undefined,
      more : false
    };

    vm.alertNickname = function(){

      if($rootScope.userInfo.nickEditable){
        $state.go('profile.nickname')
      }else{
        Toaster.confirm('昵称不可修改',';;false')
      }

    };

  }

})();

(function () {
    'use strict';
    angular.module('WASData', ['WASCommon']);
})();

(function () {
	'use strict';

	/**
	* 微信网站应用文档
	* https://open.weixin.qq.com/cgi-bin/showdocument?action=dir_list&t=resource/res_list&verify=1&id=open1419316505&token=&lang=zh_CN
	* */

	angular
		.module('WASData')
		.provider('WeixinService', function () {

			this.$get = function ($q, $rootScope, RequestService,settings) {
        var weixin = settings.weixin;
        var localUrl = location.protocol + '//' +location.host + location.pathname;

				return {
          //redirectUrl : 登陆成功之后的跳转地址
          getLoginQRCodeUrl : function(redirectUrl){
            var param = {
              appid : weixin.appid,
              redirect_uri : localUrl + '#/weixinLogin',
              response_type : 'code',
              scope : 'snsapi_login',
              state : redirectUrl ? redirectUrl : ''
            };
            return weixin.openUrl + '/connect/qrconnect?' + jQuery.param(param) + '#wechat_redirect';
          },

          //localStorage : 绑定成功之后存储localStorage
          getBindQRCodeUrl : function(localStorage){
            var param = {
              appid : weixin.appid,
              redirect_uri : localUrl + '#/weixinBind',
              response_type : 'code',
              scope : 'snsapi_login',
              state : localStorage ? localStorage : ''
            };
            return weixin.openUrl + '/connect/qrconnect?' + jQuery.param(param) + '#wechat_redirect';
          }
        }
			};
		});
})();

(function () {
	'use strict';

	/**
	* 接口文档地址
	* https://wdwiki.mapbar.com/bin/view/%E5%B9%B3%E5%8F%B0%E5%BC%80%E5%8F%91%E7%BB%84/WeCloud%E7%BB%9F%E4%B8%80%E7%94%A8%E6%88%B7%E5%B8%90%E5%8F%B7%E6%96%87%E6%A1%A3
	* */

	angular
		.module('WASData')
		.provider('UserService', function () {
			var serviceUrl = '';

			function makeUrl(path, params) {
				var queryString = params ? jQuery.param(params) : '';
				return serviceUrl + path + (queryString ? '?' + queryString : '');
			}

			this.setServiceUrl = function (url) {
				if (url) {
					serviceUrl = url;
				}
			};

      function standardResponse(result, success, failed){

        if (result.code === 200) {
          success(result.data);
        } else {
          failed(result);
        }

      }

			this.$get = function ($q, $rootScope, RequestService) {

				function makeParam(data,isStr) {
					data = data || {};
					data.product = $rootScope.product;
					return isStr === false ? data : JSON.stringify(data);
				}
				return {
          /**
           * 获取图片验证码
           * @param {object} data
           * @param {string} data.identifier 唯一标识符
           * @param {string} data.type 验证类型 取值：register,findPassword,login
           * @returns {{string}}
           */
          getCaptcha: function (data) {
            return makeUrl(
              '/getCaptcha',
              makeParam({
                identifier: data.identifier,
                type: data.type,
                t: Date.now()
              }, false));
          },

          /**
           * 验证图片验证码
           * @param {object} data 验证码配置
           * @param {string} data.verifyCode 验证码内容
           * @param {string} data.identifier 唯一标识符
           * @param {string} data.type 验证类型 取值：register,findPassword,login
           * @returns {Promise<object>}
           */
          checkCaptcha: function (data) {

            return RequestService.post(
              {
                url: makeUrl('/checkCaptcha'),
                data: makeParam(data),
                token: false
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );

          },

          /**
           * 发送手机验证码
           * @param {object} data 提交数据
           * @param {string} data.mobile 手机号
           * @param {string} data.captcha 图形验证码
           * @param {string} data.type  类型 取值： quickLogin,register,resentRegister
           * @returns {Promise<object>}
           */
          sendSms: function (data) {

            return RequestService.post(
              {
                url: makeUrl('/sendSms'),
                data: makeParam(data),
                token: false
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );
          },

          /**
           * 发送邮箱验证码
           * @param {object} data 提交数据
           * @param {string} data.email 邮箱
           * @param {string} data.captcha 图形验证码
           * @param {string} data.redirectUrl 跳转地址
           * @param {string} data.type  类型 取值： quickLogin,register,resentRegister
           * @returns {Promise<object>}
           */
          sendEmail: function (data) {

            return RequestService.post(
              {
                url: makeUrl('/sendEmail'),
                data: makeParam(data),
                token: false
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );
          },

          /**
           * 登录
           * @param {object} data
           * @param {string} data.loginName 用户名(手机号/邮箱)
           * @param {string} data.password 密码
           * @param {boolean} data.autoLogin 是否自动登录 非必须
           * @param {string} data.captcha 图形验证码 非必须
           * @returns {Promise<object>} 用户信息
           */
          login: function (data) {

            var _data = angular.copy(data);

            if (_data.autoLogin === true) {
              _data.autoLogin = 1;
            } else {
              delete _data.autoLogin;
            }

            return RequestService.post(
              {
                url: makeUrl('/login'),
                data: makeParam(_data),
                token: false
              },
              //function (result, success, failed) {
              //
              //	if (result.code === 200) {
              //		success(result.data);
              //	} else {
              //		failed(result);
              //	}
              //}
              standardResponse
            );
          },

          /**
           * 快速登录
           * @param {object} data 登录信息
           * @param {string} data.mobile 手机号
           * @param {string} data.smsCode 手机验证码
           * @param {boolean} data.autoLogin  是否自动登录
           * @returns {Promise<object>}
           */
          quickLogin: function (data) {
            var _data = angular.copy(data);

            if (_data.autoLogin === true) {
              _data.autoLogin = 1;
            } else {
              delete _data.autoLogin;
            }

            return RequestService.post(
              {
                url: makeUrl('/quickLogin'),
                data: makeParam(_data),
                token: false
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );
          },

          /**
           * 手机注册
           * @param {object} data 注册信息
           * @param {string} data.mobile 手机号
           * @param {string} data.password 密码
           * @param {string} data.smsCode 手机验证码
           * @returns {Promise<object>}
           */
          register: function (data) {

            return RequestService.post(
              {
                url: makeUrl('/mobileRegister'),
                data: makeParam(data),
                token: false
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );

          },

          /**
           * 邮箱注册
           * @param {object} data 注册信息
           * @param {string} data.email email账号
           * @param {string} data.password 密码
           * @param {string} data.redirectUrl 邮箱跳转地址
           * @param {string} data.captcha 图片验证码
           * @returns {Promise<object>}
           */
          registerByEmail: function (data) {

            return RequestService.post(
              {
                url: makeUrl('/mailRegister'),
                data: makeParam(data),
                token: false
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );

          },

          /**
           * 邮箱激活
           * @param {object} q 加密窜
           * @returns {Promise<object>}
           */
          activeEmail: function (q) {

            return RequestService.get(
              {
                url: makeUrl('/activeByMail/' + q),
                token: false
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );

          },

          /**
           * 手机号是否可用
           * @param {object} data 手机号码
           * @returns {Promise<object>}
           */
          vacantMobile: function (data) {

            return RequestService.get(
              {
                url: makeUrl('/checkMobile'),
                data: makeParam({
                  mobile: data
                }, false),
                token: false
              },
              function (result, success, failed) {

                if (result.code === 1007) {
                  success(true);
                } else {
                  failed(result);
                }
              }
            );

          },

          /**
           * 邮箱是否可用
           * @param {object} data 邮箱地址
           * @returns {Promise<object>}
           */
          vacantEmail: function (data) {

            return RequestService.get(
              {
                url: makeUrl('/checkEmail'),
                data: makeParam({
                  email: data
                }, false),
                token: false
              },
              function (result, success, failed) {

                if (result.code === 1009) {
                  success(true);
                } else {
                  failed(result);
                }
              }
            );
          },

          /**
           * 退出登录
           * @returns {Promise<Object>}
           */
          logout: function () {
            return RequestService.post(
              {
                url: makeUrl('/logout'),
                data: makeParam(),
                token: true
              },
              //function (result, success, failed) {
              //	if (result.code === 200) {
              //		//dataCatch.userInfo = null;
              //		success(result.data);
              //	} else {
              //		failed(result);
              //	}
              //}
              standardResponse
            );
          },

          /**
           * 获取当前用户的信息
           * @returns {Promise<Object>}
           */
          getUserInfo: function () {

            return RequestService.post(
              {
                url: makeUrl('/userDetail'),
                data: makeParam(),
                token: true
              },
              function (result, success, failed) {
              	if (result.code === 200) {

                  result.data.liveCity = result.data.liveCity === null ? undefined : result.data.liveCity;
                  result.data.liveDistrict = result.data.liveDistrict === null ? undefined : result.data.liveDistrict;
                  result.data.liveProvince = result.data.liveProvince === null ? undefined : result.data.liveProvince;

              		success(result.data);
              	} else {
              		failed(result);
              	}
              }
            );

          },

          /**
           * 找回密码
           */
          findPassword: {
            /**
             * 找回密码-验证账号(并发送验证码)
             * @param {object} data 请求参数
             * @param {string} data.account 账号，手机号或者email地址
             * @param {string} data.captcha 图形验证码
             * @param {string} data.type 账号类型, 取值: ’mobile’,’email’
             * @returns {Promise<object>}
             */
            checkAccount: function (data) {

              var param = {};
              var url = '';

              if (data.type === 'mobile') {
                url = '/findPasswordBySms';
                param.mobile = data.account;

              } else if (data.type === 'email') {
                url = '/findPasswordByEmail';
                param.email = data.account;
              }

              param.captcha = data.captcha;
              //param.product = product;

              //console.log(data, param, url)

              return RequestService.post(
                {
                  url: makeUrl(url),
                  data: makeParam(param),
                  token: false
                },
                //function (result, success, failed) {
                //
                //  if (result.code === 200) {
                //    success(result.data);
                //
                //  } else {
                //    failed(result);
                //
                //  }
                //}
                standardResponse
              )
            },

            /**
             * 找回密码-重发送验证码
             * @param {object} data 请求参数
             * @param {string} data.account 账号，手机号或者email地址
             * @param {string} data.captcha 图形验证码
             * @param {string} data.type 账号类型, 取值: ’mobile’,’email’
             * @returns {Promise<object>}
             */
            reSendVerifyCode: function (data) {

              var param = {};
              var url = '';

              if (data.type === 'mobile') {
                url = '/sendSms';
                param.mobile = data.account;
                param.type = 'findPassword';

              } else if (data.type === 'email') {
                url = '/sendEmail';
                param.email = data.account;
                param.redirectUrl = '';
                param.type = 'findPassword';
              }

              param.captcha = data.captcha;
              //param.product = product;

              //console.info(param)

              return RequestService.post(
                {
                  url: makeUrl(url),
                  data: makeParam(param),
                  token: false
                },
                //function (result, success, failed) {
                //
                //  if (result.code === 200) {
                //    success(result.data);
                //
                //  } else {
                //    failed(result);
                //
                //  }
                //}
                standardResponse
              )
            },

            /**
             * 找回密码-验证验证码
             * @param {object} data 请求参数
             * @param {string} data.account 账号，手机号或者email地址
             * @param {string} data.verifyCode 验证码
             * @param {string} data.type 账号类型, 取值: ’mobile’,’email’
             * @returns {Promise<object>}
             */
            checkVerifyCode: function (data) {

              var param = {};
              var url = '';

              if (data.type === 'mobile') {
                url = '/validateFindPasswordSms';
                param.mobile = data.account;
                param.smsCode = data.verifyCode;

              } else if (data.type === 'email') {
                url = '/validateFindPasswordEmail';
                param.email = data.account;
                param.verifyCode = data.verifyCode;
              }

              return RequestService.post(
                {
                  url: makeUrl(url),
                  data: makeParam(param),
                  token: false
                },
                //function (result, success, failed) {
                //
                //  if (result.code === 200) {
                //    success(result.data);
                //
                //  } else {
                //    failed(result);
                //
                //  }
                //}
                standardResponse
              )
            },

            /**
             * 找回密码-重置密码
             * @param {object} data 请求参数
             * @param {string} data.account 账号，手机号或者email地址
             * @param {string} data.verifyCode 验证码
             * @param {string} data.newPassword 新密码
             * @returns {Promise<object>}
             */
            resetPassword: function (data) {

              return RequestService.post(
                {
                  url: makeUrl('/resetPassword'),
                  data: makeParam({
                    identifier: data.account,
                    verifyCode: data.verifyCode,
                    newPassword: data.newPassword
                  }),
                  token: false
                },
                //function (result, success, failed) {
                //
                //  if (result.code === 200) {
                //    success(result.data);
                //
                //  } else {
                //    failed(result);
                //
                //  }
                //}
                standardResponse
              )
            }

          },

          /**
           * 修改密码
           * @param {object} data
           * @param {string} data.oldPassword 旧密码
           * @param {string} data.newPassword 新密码
           * @returns {Promise<Object>}
           */
          updatePassword: function (data) {
            return RequestService.post(
              {
                url: makeUrl('/updatePassword'),
                data: makeParam(data),
                token: true
              },
              //function (result, success, failed) {
              //	if (result.code === 200) {
              //		//dataCatch.userInfo.token = data.token;
              //		success(result.data);
              //	} else {
              //		failed(result);
              //	}
              //}
              standardResponse
            );
          },

          /**
           * 通过token获取用户头像
           * @returns {string}
           */
          getUserPhoto: function () {
            //return makeUrl('/queryPic') + '?token=' + $rootScope.userInfo.token;
            return makeUrl('/queryPic') + '?token=' + encodeURIComponent($rootScope.userInfo.token) + '&t=' + Date.now();
          },

          /**
           * 通过userId获取用户头像
           * @returns {string}
           */
          getUserPhotoById: function (id) {
            return makeUrl('/queryPicById') + '?userId=' + (id || $rootScope.userInfo.UserId);
            //return makeUrl('/queryPicById') + '?userId=' + (id || $rootScope.userInfo.UserId) + '&t=' + Date.now();
          },

          /**
           * 获取登录历史
           * @returns {Promise<Object>}
           */
          loginHistory: function (id) {
            return RequestService.post(
              {
                url: makeUrl('/loginHistory'),
                data : makeParam({
                  userId : id
                }),
                token: true
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            )

          },

          /**
           * 修改用户信息
           * @param {object} data 请求参数对象
           * @param {string} data.token
           * @param {string} data.nickname 昵称
           * @param {number} data.gender 性别: 0女，1男
           * @param {string} data.birthday 生日: 格式: 2013-05-04
           * @param {string} data.liveProvince 所属省
           * @param {string} data.liveCity 所属市
           * @param {string} data.liveDistrict 所属区县
           * @returns {Promise<object>}
           */
          updateUserInfo: function (data) {
            return RequestService.post(
              {
                url: makeUrl('/updateUser'),
                data: makeParam(data),
                token: true
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );

          },

          /**
           * 新增车辆信息
           * @param {object} data 请求参数对象
           * @param {string} data.token
           * @param {string} data.lisenceNo 车牌号
           * @param {string} data.engineNo 发动机号
           * @param {string} data.carBuyDate 购车日期
           * @param {string} data.carModelId 车型id
           * @returns {Promise<object>}
           */
          addCar: function (data) {

            return RequestService.post(
              {
                url: makeUrl('/updateUserCar'),
                data: makeParam(data),
                token: true
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );

          },

          /**
           * 修改车辆信息
           * @param {object} data 请求参数对象
           * @param {string} data.token
           * @param {string} data.carId 车id
           * @param {string} data.lisenceNo 车牌号
           * @param {string} data.engineNo 发动机号
           * @param {string} data.carBuyDate 购车日期
           * @param {string} data.carModelId 车型id
           * @returns {Promise<object>}
           */
          updateCar: function (data) {

            return RequestService.post(
              {
                url: makeUrl('/updateUserCar'),
                data: makeParam(data),
                token: true
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );

          },

          /**
           * 删除车辆信息
           * @param {string} id 车id
           * @returns {Promise<object>}
           */
          removeCar: function (id) {

            return RequestService.post(
              {
                url: makeUrl('/deleteUserCar'),
                data: makeParam({
                  id: id
                }),
                token: true
              },
              //function (result, success, failed) {
              //
              //  if (result.code === 200) {
              //    success(result.data);
              //  } else {
              //    failed(result);
              //  }
              //}
              standardResponse
            );

          },

          /**
           * 申请修改绑定手机
           * @param {object} data 请求参数对象
           * @param {string} data.token
           * @param {string} data.mobile 手机号
           * @param {string} data.type 类型 取值：bind,changeBind
           * @returns {Promise<object>}
           */
          applyBindMobile : function (data) {

            return RequestService.post(
              {
                url: makeUrl('/applyBindMobile'),
                data: makeParam(data),
                token: true
              },
              standardResponse
            );

          },

          /**
           * 验证修改绑定手机
           * @param {object} data 请求参数对象
           * @param {string} data.token
           * @param {string} data.mobile 旧手机号
           * @param {string} data.smsCode 短信验证码
           * @returns {Promise<object>}
           */
          checkChangeMobile : function (data) {

            return RequestService.post(
              {
                url: makeUrl('/checkChangeBindMobile'),
                data: makeParam(data),
                token: true
              },
              standardResponse
            );

          },

          /**
           * 绑定手机
           * @param {object} data 请求参数对象
           * @param {string} data.token
           * @param {string} data.mobile 手机号
           * @param {string} data.smsCode 短信验证码
           * @param {string} data.oldMobile 旧手机号 非必填，如果是更换绑定则必填
           * @param {string} data.oldSmsCode 旧短信验证码 非必填，如果是更换绑定则必填
           * @param {string} data.type 类型 取值：bind,changeBind
           * @returns {Promise<object>}
           */
          bindMobile : function (data) {

            return RequestService.post(
              {
                url: makeUrl('/bindMobile'),
                data: makeParam(data),
                token: true
              },
              standardResponse
            );

          },

          /**
           * 申请(修改)绑定邮箱
           * @param {object} data 请求参数对象
           * @param {string} data.token
           * @param {string} data.email 邮箱地址
           * @param {string} data.type 类型 取值：bind,changeBind
           * @returns {Promise<object>}
           */
          applyBindEmail : function (data) {

            return RequestService.post(
              {
                url: makeUrl('/applyBindEmail'),
                data: makeParam(data),
                token: true
              },
              standardResponse
            );

          },

          /**
           * 验证修改绑定邮箱
           * @param {object} data 请求参数对象
           * @param {string} data.token
           * @param {string} data.email 旧邮箱地址
           * @param {string} data.verifyCode 邮箱验证码
           * @returns {Promise<object>}
           */
          checkChangeEmail : function (data) {

            return RequestService.post(
              {
                url: makeUrl('/checkChangeBindEmail'),
                data: makeParam(data),
                token: true
              },
              standardResponse
            );

          },

          /**
           * 绑定邮箱
           * @param {object} data 请求参数对象
           * @param {string} data.token
           * @param {string} data.email 邮箱地址
           * @param {string} data.verifyCode 邮箱验证码
           * @param {string} data.oldEmail 旧邮箱地址 非必填，如果是更换绑定则必填
           * @param {string} data.oldVerifyCode 旧邮箱验证码 非必填，如果是更换绑定则必填
           * @param {string} data.type 类型 取值：bind,changeBind
           * @returns {Promise<object>}
           */
          bindEmail : function (data) {
            return RequestService.post(
              {
                url: makeUrl('/bindEmail'),
                data: makeParam(data),
                token: true
              },
              standardResponse
            );
          },

          /**
           * 上传头像
           * @param {object} data 头像文件
           * @returns {Promise<object>}
           */
          uploadPhoto : function (data) {
            return RequestService.post(
              {
                url: makeUrl('/uploadPic'),
                data: {file : data},
                token: true
              },
              standardResponse
            );

          },
          /**
           * 登陆验证
           * @returns {Promise<object>}
           */
          validateLogin : function(){
            return RequestService.post(
              {
                url: makeUrl('/validateLogin'),
                data : '',
                token: false
              },
              standardResponse
            );
          },
          /**
           * 微信登陆
           * @param {object} code
           * @returns {Promise<object>}
           */
          weixinLogin : function (code) {
            return RequestService.post(
              {
                url: makeUrl('/webThirdLogin'),
                data: makeParam({
                  code : code,
                  type : 'weixin'
                }),
                token: false
              },
              standardResponse
            );
          },

          /**
           * 关联微信
           * @param {object} code
           * @returns {Promise<object>}
           */
          weixinBind : function (code) {

            return RequestService.post(
              {
                url: makeUrl('/webBindThridPlatform'),
                data: makeParam({
                  code : code,
                  type : 'weixin'
                }),
                token: true
              },
              standardResponse
            );

          },

          /**
           * 第三方账号解绑
           * @param {object} type  第三方类型, 取值: ’qq’,’weixin’
           * @returns {Promise<object>}
           */
          unbindThridParty : function (type) {

            return RequestService.post(
              {
                url: makeUrl('/unbindThridPlatform'),
                data: makeParam({
                  type : type
                }),
                token: true
              },
              standardResponse
            );
          },

          /**
           * sso验证登录
           * @returns {Promise<object>}
           * */
          validateSSOLogin : function(){
            return RequestService.get(
              {
                url: makeUrl('/validateSSOLogin'),
                token: false
              },
              standardResponse
            );
          },

          /**
           * sso登出
           * @returns {Promise<object>}
           * */
          ssoLogout : function(){
            return RequestService.get(
              {
                url: makeUrl('/ssoLogout'),
                token: false
              },
              standardResponse
            );
          }

				};
			};
		});
})();

/**
 * 失败,成功,确认弹出框
 * */
(function () {
    'use strict';

    angular
        .module('WASData')
        .provider('Toaster', function () {
            this.$get = function (toaster, $rootScope, $timeout) {

              $rootScope.confirm = {
                open : false,
                title : '提示',
                content : 'it is work!',
                onCancel : null,
                onOk : null,
                cancel : function(){
                  this.open = false;
                  if(angular.isFunction(this.onCancel)){
                    this.onCancel();
                  }
                  this.onCancel = null;

                },
                ok : function(){
                  this.open = false;
                  if(angular.isFunction(this.onOk)){
                    this.onOk();
                  }
                  this.onOk = null;
                }
              };

              $rootScope.terms = {
                open : false
              };

              return {
                  success : function(text){
                    text !== null && toaster.pop('success',text)
                  },
                  error : function(text){
                    text !== null && toaster.pop('error',text)
                  },
                  confirm : function (message, title, ok, cancel) {
                    var text = title ? title.split(';') : [];

                    $rootScope.confirm.open = true;
                    $rootScope.confirm.title = text[0] || '提示';
                    $rootScope.confirm.onText = text[1] || '确定';
                    $rootScope.confirm.cancelText = text[2] || '取消';
                    $rootScope.confirm.content = message || '';
                    $rootScope.confirm.showCancel = text[2] !== 'false';

                    if(angular.isFunction(ok)){
                      $rootScope.confirm.onOk = ok;
                    }

                    if(angular.isFunction(cancel)){
                      $rootScope.confirm.onCancel = cancel;
                    }
                  },
                  terms : function(){
                    $rootScope.terms.open = true;
                  }

                };

            };
        });
})();

/**
 * 发送验证码按钮组件
 * */
(function () {

  angular
    .module('wedriveUsercenterWeb')
    .directive('mgVcodeButton', mgVcodeButton);

  /** @ngInject */
  function mgVcodeButton(Toaster,$interval,$timeout) {
    /**
     * options :
     *  {
     *    service <function>  接口服务(必须)
     *    params  <object>    给接口的参数(必须)
     *    name    <string>    字段名,用于验证目标地址可用(非必须)
     *    beforeSend <function>  调用service 之前执行, 如果return false, 则不调用service
     *    success <function>  发送成功回调(非必须)
     *    error   <function>  发送失败回调(非必须)
     *    autoCD  <boolean>   是否自动倒计时(非必须) 0或不传:不自动倒计时 1:自动倒计时但不自动发送 2:自动倒计时并发送
     *  }
     *
     * sent : 发送成功后置为true
     * */
    return {
      scope : {
        options : '=mgVcodeButton',
        sent : '='
      },
      require: '^^form',
      link: function (scope, element, attr, formCtrl) {

        var timer = null;
        var text = element.html();
        var targetName = '';
        scope.valid = true;
        scope.inCD = false;

        $timeout(function(){

          scope.model = formCtrl[scope.options.name];

          if(scope.options.name){
            scope.$watch('model.$valid',function(valid){
              scope.valid = valid;
              changeDisabled();
            });
          }

          if(scope.options.autoCD === 1){
            CD();
          }else if(scope.options.autoCD === 2){
            beforeSend();
          }

        },100);

        //scope.options.autoCD && CD();

        element.on('mousedown', beforeSend);

        function changeDisabled(){
          element.prop('disabled',!scope.valid || scope.inCD)
        }

        function clearCD(){
          $interval.cancel(timer);
          scope.inCD = false;
          element.html(text);
          changeDisabled();
          timer = null;
        }

        function CD() {
          scope.inCD = true;
          changeDisabled();

          var sec = 60;

          interval();
          timer = $interval(interval, 1000);

          function interval(){
            element.html('重新发送('+(sec--)+')');
            sec < 0 && clearCD();
          }
        }

        function beforeSend(){
          if(angular.isFunction(scope.options.beforeSend)){

            var res = scope.options.beforeSend();

            if(res !== false){
              if(res && angular.isFunction(res.then)){
                res.then(function(){
                  send();
                });
              }else{
                send();
              }
            }

          }else{
            send();
          }

        }

        function send(){
          CD();

          var params = angular.copy(scope.options.params);

          //把$value替换成手机号/邮箱地址
          if(scope.options.name){
            for(var n in scope.options.params){
              if(params[n] === '$value'){
                targetName = n;
                params[n] = scope.model.$modelValue
              }
            }
          }

          if(targetName){
            params[targetName] = scope.model.$modelValue
          }

          scope.options.service(params).then(function(data){
            Toaster.success('验证码已发送，请查收');
            if(!angular.isUndefined) scope.sent = true;
            scope.options.success && scope.options.success(data)
          },function(err){

            if(err.code === 1030 || err.code === 1031){
              Toaster.error('验证码发送过于频繁，请稍后再试');
            }else{
              Toaster.error('验证码发送失败，请稍后再试');
            }

            clearCD();

            scope.options.error && scope.options.error(err);
          });
        }

      }
    }
  }

})();

/**
 * 文字内容格式化
 * */
(function () {

  angular
    .module('wedriveUsercenterWeb')
    .directive('mgTextTransform', mgTextTransform);

  /** @ngInject */
  function mgTextTransform() {

    var transformConfig = {
      uppercase: function(input){
        return input.toUpperCase();
      },
      capitalize: function(input){
        return input.replace(
          /([a-zA-Z])([a-zA-Z]*)/gi,
          function(matched, $1, $2){
            return $1.toUpperCase() + $2;
          });
      },
      lowercase: function(input){
        return input.toLowerCase();
      },
      password : function(input){
        var reg = /[^\w\`\~\!\@\#\$\%\^\&\*\(\)\+\-\=\{\}\|\:\"\<\>\?\[\]\\\;\'\,\.\/]/g;
        return input.replace(reg,'').toLowerCase();
      }
    };

    return {
      require: 'ngModel',
      link: function(scope, element, iAttrs, modelCtrl) {

        var transform = transformConfig[iAttrs.mgTextTransform];
        if(transform){
          modelCtrl.$parsers.push(function(input) {
            return transform(input || "");
          });

          element.css("text-transform", iAttrs.mgTextTransform);
        }
      }
    };
  }

})();

/**
 * 边栏组件
 * */
(function () {

  angular
    .module('wedriveUsercenterWeb')
    .directive('mgSidebar', mgSidebar);

  /** @ngInject */
  function mgSidebar($window, $location) {
    return {
      restrict: 'AE',
      replace : true,
      scope : {
        data : '=mgSidebar',
        active : '='
      },
      templateUrl: 'app/components/sidebar/sidebar.html',
      link: function (scope, element, attr, controller) {
        //scope.active = 'profile.basicInfo';
        //scope.data =


      }
    };
  }

})();

/**
 * 选择地区组件
 * eg: <div mg-region-selector province="" city="" district="" valid="" bubble=""></div>
 * */

(function() {
  'use strict';

  angular.module('wedriveUsercenterWeb')
    .factory('LocationService',function($q, $rootScope, RequestService, settings){

      return function(data){

        return RequestService.get(
          {
            url: settings.userCenterServiceUrl + '/location/query',
            data: data,
            token: false,
            cache: true
          },
          function (result, success, failed) {

            if (result.code === 200) {
              success(result.data);
            } else {
              failed(result);
            }
          }
        );
      };
    })

    .directive('mgRegionSelector', function (LocationService,$timeout) {
      return {
        scope : {
          province : '=', //省份
          city : '=', //城市
          district : '=', //区县
          //region : '=', //地区总称(省+市+区;如果省和市名称相同,会省略市;也存在没有市或区的情况)
          valid : '=', //是否全部选择
          bubble : '@' //提示
        },
        templateUrl : 'app/components/regionSelector/regionSelector.html',
        link : function ($scope,$element) {
          $scope.dirty = false;

          var initValue = {
            p : $scope.province || '',
            c : $scope.city || '',
            d : $scope.district || ''
          };

          $scope.province = undefined;
          $scope.city = undefined;
          $scope.district = undefined;

          /* 三个select元素 */
          var select = $element.find('select');

          /* 所有选项的数据模型 */
          $scope.data = {
            province : '',
            city : '',
            district : ''
          };

          /* select的显示和禁用状态 */
          $scope.status = {
            p : {
              show : true,
              disabled : false
            },
            c : {
              show : true,
              disabled : true
            },
            d : {
              show : true,
              disabled : true
            }
          };

          /* 默认加载省级数据 */
          LocationService().then(function(data){

            $scope.data.province = data;

            if(!!initValue.p){

              $timeout(function(){
                $scope.province = initValue.p;
              })
            }

          });

          $timeout(function(){
            $scope.$watch('province',L1);
          });

          function L1(){

            var val = this.last;

            if(angular.isDefined(val)){
              $scope[this.exp] = this.last;
              $scope.city = initValue.c || '';
              $scope.district = initValue.d || '';

              if(this.last === ''){
                $scope.status.c.disabled = true;
                $scope.status.d.disabled = true;

              }else{
                $scope.status.c.disabled = false;

                $timeout(function(){
                  LocationService({
                    parentId : select.eq(0).find('[value='+ val +']').data('index')
                  }).then(function(data){

                    $scope.status.c.show = true;
                    $scope.status.d.show = true;

                    if(data.length < 1){ //没有市一级,如:台湾省
                      $scope.status.c.show = false;
                      $scope.status.d.show = false;
                      getValue(true)

                    }else if(data.length === 1){ //省和市相同的情况,如:北京
                      $scope.status.c.show = false;
                      $scope.city = data[0].name;
                      select.eq(1).data('pid',data[0].id);

                    }

                    if(!!initValue.c){

                      $timeout(function(){
                        select.eq(1).val(initValue.c);
                        initValue.c = '';
                      });
                    }

                    $scope.data.city = data;
                  });
                })

              }

              getValue()
            }
          }

          $timeout(function(){
            $scope.$watch('city',L2);
          });

          function L2(){
            var val = this.last;
            var _tmp;

            if(angular.isDefined(val)){
              //console.log(val)

              $scope[this.exp] = val;
              _tmp = angular.copy($scope.district);

              $scope.district = '';

              if(val === ''){
                $scope.status.d.disabled = true;

              }else{
                $scope.status.d.disabled = false;
                $timeout(function(){
                  var query = select.eq(1).find('[value='+ val +']').data('index');

                  LocationService({
                    parentId : query
                  }).then(function(data){

                    if(data.length < 1){ //没有区县级,如:广东省-中山市等
                      $scope.status.d.show = false;
                      getValue(true);

                    }else{
                      $scope.data.district = data;
                      $scope.status.d.show = true;

                    }

                    if(!!initValue.d) {
                      $timeout(function () {
                        select.eq(2).val(initValue.d);
                        initValue.d = '';
                        $scope.valid = true;
                      })
                    }

                  });
                },!!initValue.d ? 600 : 0);

              }

              getValue(!!_tmp)
            }
          }

          $timeout(function(){
            $scope.$watch('district',L3);
          });

          function L3(){

            if(angular.isDefined(this.last)){
              $scope[this.exp] = this.last;
              getValue()
            }
          }

          /* 计算region,valid */
          function getValue(isValid){
            var p = $scope.province,
                c = $scope.city,
                d = $scope.district;

            if(initValue.p && !$scope.dirty){
              $timeout(function(){
                $scope.dirty = true;
              },800);
            }else if(p || c || d){
              $scope.dirty = true;
            }

            $scope.region = p === c ? p + d : p + c + d;
            $scope.valid = isValid ? isValid : !!p && !!c && !!d;

            //console.log(isValid ,p , c , d)
          }

        }
      };
    });

})();

/**
 * 车牌归属地省份简称组件
 * eg: <div mg-province-selector="" ></div>
 * */

(function() {
  'use strict';

  angular.module('wedriveUsercenterWeb')
    .factory('LicenceProvince',function($q, $rootScope, RequestService, settings){

      return function(data){

        return RequestService.get(
          {
            url: settings.userCenterServiceUrl + '/location/lisenceNoMappings',
            data: data,
            token: false,
            cache: true
          },
          function (result, success, failed) {

            if (result.code === 200) {
              success(result.data);
            } else {
              failed(result);
            }
          }
        );
      };
    })

    .directive('mgProvinceSelector', function (LicenceProvince,$timeout) {
      return {
        scope : {
          province : '=mgProvinceSelector'
        },
        templateUrl : 'app/components/provinceSelector/provinceSelector.html',
        link : function ($scope) {
          $scope.data = [];

          $scope.province = $scope.province || '京';

          LicenceProvince().then(function(data){
            $scope.data = sortFilter(data)
          })

        }
      };
    });

  function sortFilter(data){
    var aReg = /[a-z]/i,
      obj = {},
      arr = [];

    data.forEach(function(val){
      var s = getSrotName(val.capital);
      if(!obj[s]) obj[s] = [];
      obj[s].push(val)
    });

    for(name in obj){
      var dl = obj[name];
      dl._sortKey = name;
      arr.push(dl)
    }

    arr.sort(function(n,m){
      return n._sortKey < m._sortKey ? -1 : 1;
    });

    function getSrotName (name){
      var a = name.charAt(0);
      return aReg.test(a) ? a.toUpperCase() : '#';
    }

    return arr;
  }

})();

/**
 * 使IE9,IE8兼容 placeholder
 * origin: http://pinkyjie.com/2014/08/06/solve-placeholder-incompatibility-using-angular-on-legacy-ie/
 */

angular
  .module('wedriveUsercenterWeb')
  .directive('placeholder', ['$compile', function($compile){
  return {
    restrict: 'A',
    scope: {},
    link: function(scope, ele, attr) {
      var input = document.createElement('input');
      var isSupportPlaceholder = 'placeholder' in input;
      //var isSupportPlaceholder = false;

      if (!isSupportPlaceholder) {
        var fakePlaceholder = angular.element(
          '<span class="placeholder">' + attr['placeholder'] + '</span>');
        fakePlaceholder.on('click', function(e){
          e.stopPropagation();
          ele.focus();
        });
        ele.before(fakePlaceholder);
        $compile(fakePlaceholder)(scope);

        ele.on('focus', function(){
          //if (ele.val() !== '') {
            fakePlaceholder.hide();
          //}

        }).on('blur', function(){
          if (ele.val() === '') {
            fakePlaceholder.show();
          }
        });

        scope.getElementPosition = function() {
          return ele.position();
        };
        scope.$watch(scope.getElementPosition, function(){
          fakePlaceholder.css({
            'top': ele.position().top + 'px',
            'left': ele.position().left + 'px'
          });
        }, true);

        scope.getElementHeight = function() {
          return ele.outerHeight();
        };
        scope.$watch(scope.getElementHeight, function(){
          fakePlaceholder.css('line-height', ele.outerHeight() + 'px');
        });
        if (ele.css('font-size')){
          fakePlaceholder.css('font-size', ele.css('font-size'));
        }
        if (ele.css('text-indent')){
          fakePlaceholder.css('text-indent',
            parseInt(ele.css('text-indent')) +
            parseInt(ele.css('border-left-width'))
          );
        }
        if (ele.css('padding-left')){
          fakePlaceholder.css('padding-left', ele.css('padding-left'));
        }
        if (ele.css('margin-top')){
          fakePlaceholder.css('margin-top', ele.css('margin-top'));
        }

        scope.isElementVisible = function(){
          return ele.is(':visible');
        };
        scope.$watch(scope.isElementVisible, function(){
          var displayVal = ele.is(':visible') ? 'block' : 'none';
          fakePlaceholder.css('display', displayVal);
          if (displayVal === 'blcok' && ele.val()) {
            fakePlaceholder.hide();
          }
        });

        scope.hasValue = function(){
          return ele.val();
        };

        scope.$watch(scope.hasValue, function(){

          if (ele.val()) {
            fakePlaceholder.hide();
          }
        });


      }

    }
  };
}]);

/**
 * 头像组件
 * */

(function() {
  'use strict';

  angular.module('wedriveUsercenterWeb')

  .directive('mgPhoto', function () {
    return {
      link : function ($scope,$element) {

        var ele = $element.eq(0);

        ele.on('load',function(){
          ele
            .css({display : 'block'})
            .parent().addClass('photo-hideBG');
        });

        ele.on('error',function(){
          ele
            .css({display : 'none'})
            .parent().removeClass('photo-hideBG');
        })
      }
    };
  });

})();

(function() {
  'use strict';

  angular
    .module('wedriveUsercenterWeb')


    /**
     * 类似于ngMessage的表单提示指令
     *
     * 使用前提
     *  1.必须在表单内（<form name=xxx></form>）使用,form必须有name属性
     *  2.字段必须有name属性*
     *
     *  使用方法基本与ngMessage相同，添加了asMessageInfo指令用来显示表单填写提示（不是验证错误）
     *  asMessageInfo 中 asAlwaysShow='true' 时，info提示一直显示，否则则会在验证通过后消失
     *
     *  示例
     * <div as-messages="{{填写表单字段name}}">
     <div as-message="required">请输入一句话描述</div>
     <div as-message="minlength,maxlength">请输入10-30字</div>
     <div as-message-info="" as-always-show="true" class="as-help">
     字数：10-30字（包括标点符号） <br/>
     一句话描述：手机端应用列表中展示 <br/>
     不能有“#&”等特殊符号
     </div>
     </div>
     *
     *
     */
    .directive('asMessages', asMessages)
    .directive('asMessage', asMessage)
    .directive('asMessageInfo',asMessageInfo);

  function asMessages($timeout) {
    var setSubmittedTimeOut;
    return {
      templateUrl : 'app/components/message/message.html',
      scope : true,
      replace : true,
      transclude : true,
      require: '^^form',
      link: function ($scope, $elem, $attrs, fromCtrl) {

        /*
         * 第一种情况：页面打开时，没有提示
         * 第二种情况：光标放入文本框时（focused）(没有值)，不提示err，如果有info仅提示info,
         * 第三种情况：光标放入文本框时（focused）(有值)，提示err，如果有info提示info
         * 第四种情况：光标离开文本框时（!focused）(没有值)，不提示err，如果有info仅提示info
         * 第五种情况：光标离开文本框时（!focused）(有值)，提示err，如果有info提示info
         * 第六种情况：点击提交按钮时，提示所有err，如果有info提示info
         */

        var elName = $attrs.asMessages;
        var formElement = angular.element('form[name="' + fromCtrl.$name + '"]');
        var element = formElement.find('[name="' + elName + '"]').eq(0);

        $scope.formModel = fromCtrl;
        $scope.model = fromCtrl[elName];

        element.bind('focus', function() {
          $timeout(function () {
            $scope.focused = true;
            $scope.submitted = false;
          },100);
        }).bind('blur', function() {
          $timeout(function () {
            $scope.focused = false;
          },100);
        });

        $scope.$watchCollection('model.$error', function (collection) {
          $scope.submitted = false;
          $scope.isErrorShow = false;

          $scope.valids.forEach(function (valid) {

            if (collection[valid] === true && contains(collection, valid) && !$scope.isErrorShow){
              $scope.ctrls[valid].show();
              $scope.isErrorShow = true;
            }else{
              $scope.ctrls[valid].hide();
            }
          });
        });

        formElement.on('submit', function () {
          $scope.$apply(function () {
            $scope.submitted = true;
          });
        });

      },
      controller: function ($element, $scope, $attrs) {
        $scope.valids = [];
        $scope.ctrls = {};
        this.add = function (valid, ctrl) {
          $scope.valids.push(valid);
          $scope.ctrls[valid] = ctrl;
        };
        this.addInfo = function (alwaysShow, ctrl) {
          ctrl.show($element);
          $scope.isInfoShow = true;
          $scope.isAlwaysShowInfo = alwaysShow;
        };
      }
    };
  }

  function asMessage(){
    return {
      transclude : 'element',
      terminal: true,
      require: '^^asMessages',
      link: function (scope, element, attrs, ngMessagesCtrl, $transclude) {
        var staticExp = attrs.asMessage, isShow = false;
        ngMessagesCtrl.add(staticExp,{
          show : function () {
            !isShow && $transclude(scope, function(el){
              isShow = true;
              element.after(el[0]);
            });
          },
          hide : function () {
            if(isShow){
              element.next().remove();
              isShow = false;
            }
          }
        });
      }
    };
  }

  function asMessageInfo(){
    return {
      transclude : 'element',
      terminal: true,
      require: '^^asMessages',
      link: function (scope, element, attrs, ngMessagesCtrl, $transclude) {
        var alwaysShow = !!attrs.asAlwaysShow || false;
        ngMessagesCtrl.addInfo(alwaysShow, {
          show : function ($element) {
            $transclude(scope, function(el){
              $element.find('.as-bubble-message-info').append(el[0]);
            });
          }
        });
      }
    };
  }

  function contains(collection, key) {
    return key.split(',').some(function (_key) {
      _key = _key.replace(/(^\s*)|(\s*$)/g, "");
      if (collection) {
        return angular.isArray(collection)
          ? collection.indexOf(_key) >= 0
          : collection.hasOwnProperty(_key);
      }else{
        return false;
      }
    });
  }
})();

/**
 * 输入框控制按钮
 *
 * eg:
 * <div mg-input="">
 *     <input type="text">
 * </div>
 *
 * 现支持type = text(清空),password(文字和圆点切换,清空)
 * */

(function() {
  'use strict';

  angular.module('wedriveUsercenterWeb')

    .directive('mgInput', function ($timeout) {
      return {
        templateUrl : 'app/components/input/input.html',
        restrict : 'A',
        scope : {
          value : '=mgInput'
        },
        transclude : true,
        link : function (scope,element) {

          var $input = element.find('input').eq(0);
          var $ico = element.find('.mg-input-ico'); //0:text 1:password
          var type = $input.attr('type');

          scope._value = false;

          element.addClass('mgInput');

          if(type === 'text'){
            $ico.eq(1).hide();

          }else if(type === 'password'){

          }else{
            $ico.hide();
            return;
          }

          scope.clear = function (){
            scope.value = '';
            scope._value = false;
            $input.focus();
            //scope.$digest();
          };

          scope.showPassword = function (){
            $input.attr('type','text');
          };

          scope.hidePassword = function (){
            $input.attr('type','password');
            $input.focus();
          };

          $input.on('input',function(){
            scope._value = !!$input.val();
            scope.$digest();
          });

          $timeout(function(){
            scope._value = !!$input.val();
          });
        }
      };
    });


})();

/**
 * 头部组件
 * */

(function () {

  angular
    .module('wedriveUsercenterWeb')
    .directive('mgHeader', mgHeader);

  /** @ngInject */
  function mgHeader($window, $location, $rootScope) {
    return {
      restrict: 'AE',
      replace : true,
      templateUrl: 'app/components/header/header.html',
      link: function (scope, element, attr, controller) {

        scope.title = '';
        $rootScope.noAccess = false;
        scope.status = 0; //0:登录 1:注册 2:忘记密码
        scope.top = ''; //home:主页 security:账号安全 profile:我的资料
        scope.hidden = false;

        scope.$watch('toStatus', function (newValue) {
          //console.log(newValue.name,newValue.title);

          var name = newValue.name || '';
          var route = name.split('.');

          //scope.hidden = route[0] === 'activateEmail';
          scope.hidden = route[0] === 'redirect';

          if(route[0] === 'noAccess'){
            scope.title = newValue.title;
            $rootScope.noAccess = true;
            //$('body').css('background','#f7f7f7');

            switch (route[1]){
              case 'login':
                scope.status = 0;
                break;

              case 'registerM':
                scope.status = 1;
                break;

              case 'registerE':
                scope.status = 1;
                break;

              case 'findPassword':
                scope.status = 2;
                break;
            }

          }else{

            scope.title = '';
            $rootScope.noAccess = false;
            scope.top = route[0];

            //$('body').css('background','#ffffff');

          }

        });
      }
    };
  }

})();

/**
 * eg: <div mg-date-selector="" valid="" bubble=""></div>
 * */

(function() {
  'use strict';
  angular.module('wedriveUsercenterWeb')
    .directive('mgDateSelector', function ($timeout) {
      return {
        scope : {
          date : '=mgDateSelector',
          //change : '=',
          valid : '=',
          bubble : '@'
        },
        templateUrl : 'app/components/dateSelector/dateSelector.html',
        link : function ($scope,$element) {
          $scope.dirty = false;

          $timeout(function(){
            $scope.delay = true;
          },400);

          /* change方法 */
          $scope.change = function(date){
            var arr = date ? date.split('-') : ['','',''];
            $scope.year = arr[0] - 0;
            $scope.month = arr[1];
            $timeout(function(){
              $scope.day = arr[2];
            });

          };

          /* 给定初始值 */
          if($scope.date){
            $timeout(function(){
              $scope.change($scope.date);
            })
          }

          /* 三个select元素 */
          var select = $element.find('select');

          /* 所有选项的数据模型,年和月是固定的,日不固定 */
          var model = bulidModel();
          $scope.data = {
            year : model.year,
            month : model.month,
            day : model.day
          };

          $scope.$watch('year',function(){

            if(angular.isDefined(this.last)){
              formatterSelect();
              getValue();
            }

          });

          $scope.$watch('month',function(){

            if(angular.isDefined(this.last)){
              formatterSelect();
              getValue();
            }

          });

          $scope.$watch('day',function(){

            if(angular.isDefined(this.last)){
              getValue();
            }

          });


          var now2 = new Date();
          var toYear = now2.getFullYear(),
              toMonth = now2.getMonth() + 1,
              toDay = now2.getDate();

          function formatterSelect(){

            /* 已选择年和月的情况下,计算当月的天数 */
            if($scope.year && $scope.month){
              var oDate = new Date($scope.year,$scope.month,1);

              oDate.setDate(0);

              var days = oDate.getDate();

              if($scope.day && $scope.day > days){
                $scope.day = '';
              }
              $scope.data.day = model.day.slice(0,days);

            }

            /**
             * 禁用超过今天的月和日:
             * option的循环由ng-repeat改成ng-options了
             * 但是ng-options (此版本)不支持disable关键字
             * 故使用jquery方法控制option的disabled
             *
             * */
            //for(var i= 0,m; m=$scope.data.month[i]; i++){
            //  m.disabled = $scope.year >= toYear && i >= toMonth;
            //}
            select.eq(1).find('option').each(function(_i){
              var i = _i - 1;
              $(this).prop('disabled',$scope.year >= toYear && i >= toMonth);
            });

            if($scope.year >= toYear && $scope.month > toMonth){
              $scope.month = '';
            }

            //for(var j= 0,d; d=$scope.data.day[j]; j++){
            //  d.disabled = $scope.year >= toYear && $scope.month >= toMonth && j >= toDay;
            //}
            select.eq(2).find('option').each(function(_j){
              var j = _j - 1;
              $(this).prop('disabled',$scope.year >= toYear && $scope.month >= toMonth && j >= toDay);
            });

            if($scope.year >= toYear && $scope.month >= toMonth && $scope.day > toDay){
              $scope.day = '';
            }

          }

          /* 计算date,valid */
          function getValue(){
            $scope.dirty = true;
            var y = $scope.year,
                m = $scope.month,
                d = $scope.day;

            if(y && m && d){
              $scope.date = y + '-' + m + '-' + d;
            }else{
              $scope.date = '';
            }

            if(y && !m){
              $scope.date = y;
              $scope.valid = false;

            }else if(y && m && !d){
              $scope.date = y + '-' + m;
              $scope.valid = false;

            }else if(y && m && d){
              $scope.date = y + '-' + m + '-' + d;
              $scope.valid = true;

            }else{
              $scope.date = '';
              $scope.valid = true;

            }

            //console.log($scope.date,$scope.valid)
          }

        }
      };
    });

  function toDouble(n){
    return n < 10 ? '0' + n : '' + n;
  }

  function bulidModel(){
    var yearTemplate = [],
        monthTemplate = [],
        dayTemplate = [],
        now = new Date(),
        year = now.getFullYear();

    //今年往回数80年
    for(var i=0; i<80; i++){
      yearTemplate.push(year--)
    }

    //一年12个月
    for(var j=0; j<12; j++){
      monthTemplate[j] = {
        value : toDouble(j+1),
        disabled : false
      }
    }

    //一个月最多31天
    for(var k=0; k<31; k++){
      dayTemplate[k] = {
        value : toDouble(k+1),
        disabled : false
      }
    }

    return {
        year : yearTemplate,
        month : monthTemplate,
        day : dayTemplate
    }
  }

})();

/**
 *
 * 倒计时关闭页面
 * eg:
 * <div mg-close-window-button="关闭" cd="10"></div>
 *
 * */

(function() {
  'use strict';

  angular.module('wedriveUsercenterWeb')

    .directive('mgCloseWindowButton', function ($interval) {
      return {
        scope : {
          text : '@mgCloseWindowButton',
          cd : '@cd'
        },
        replace : true,
        templateUrl : 'app/components/closeWindowButton/closeWindowButton.html',
        link : function ($scope) {

          $scope.closeWindow = function (){
            $interval.cancel(timer);
            window.opener = null;
            window.open('','_self');
            window.close();
          };

          var timer = null;

          startCD();

          function startCD(){
            timer = $interval(function(){
              $scope.cd --;
              !$scope.cd &&  $scope.closeWindow();
            },1000)
          }
        }
      };
    });

})();

/**
 * 车型选择组件
 * eg: <div mg-car-model-selector="" icon="" valid="" show-bubble="" bubble=""></div>
 * */

(function() {
  'use strict';

  angular.module('wedriveUsercenterWeb')
    .factory('CarModelService',function($q, $rootScope, RequestService, settings){

      return function(dataField){

        var isFirstLevel = false,
            param;

        if(dataField === ''){
          param = {};
          isFirstLevel = true;
        }else{
          param = JSON.parse(decodeURI(dataField));
        }

        param.lan = 1; //中文

        dataField = 'carType_' + dataField;

        function formatterCarId(item,param){
          if(item.t_brand){
            param.t_Brand = item.t_brand;
            return JSON.stringify(param);
          }else{
            return '1';
          }
        }

        return RequestService.get(
          {
            url: settings.carModelServiceUrl + '/firmwareUpgrade/queryBrand',
            headers: {
              'Content-Type' : 'text/plain'
            },
            withCredentials : false,
            data: param,
            token: false,
            cache: true
          },
          function (result, success, failed) {

            if(result.length && result.length >= 1){
              var arr;
              if(isFirstLevel){
                arr = result.map(function(item){
                  return {
                    name : item.f_brand,
                    id : '{"f_Brand":"'+item.f_brand+'"}',
                    carIcon : item._logo,
                    sortBy : item._first_letter
                  }
                });

              }else{
                arr = result.map(function(item){
                  return {
                    name : item.t_brand ? item.t_brand : item.model_year,
                    id : formatterCarId(item,param),
                    sortBy : false
                  }
                });
              }
              success(arr);
            }else{
              failed({
                message : '无数据'
              });
            }
          }
        );
      };
    })

    .directive('mgCarModelSelector', function (CarModelService,$timeout) {
      return {
        scope : {
          model : '=mgCarModelSelector', //形如["阿斯顿·马丁","ONE-77","one-77 2011款"]的字符串,需要拆分成'品牌','车型','年款'三级
          icon : '=', //选择第一级'品牌'时,会拿到icon地址
          valid : '=', //是否全部选择
          showBubble : '=', //强制显示提示
          bubble : '@' //提示
        },
        templateUrl : 'app/components/carModelSelector/carModelSelector.html',
        link : function ($scope,$element) {

          $scope.dirty = false;

          /* 三级select值 */
          //$scope.l1 = undefined;
          //$scope.l2 = undefined;
          //$scope.l3 = undefined;

          /* 初始值 */
          var initValue = [];
          var hasInitVal = false;

          try{
            var arr = JSON.parse($scope.model);
            initValue = angular.isArray(arr) ? arr : [];
            hasInitVal = initValue.length > 0;
          }catch(e){}

          /* 三个select元素 */
          var select = $element.find('select');

          /* 三个select的option数据模型 */
          $scope.data = {
            l1 : [],
            l2 : [],
            l3 : []
          };

          /* 三个select的禁用状态 */
          $scope.status = {
            l1 : false,
            l2 : true,
            l3 : true
          };

          /* 默认加载L1数据 */
          CarModelService('').then(function(data){
            $scope.data.l1 = sortFilter(data);

            if(!!initValue[0]){

              $timeout(function(){
                $scope.l1 = initValue[0];
                //initValue[0] = '';
              })

            }
          });

          $timeout(function(){
            $scope.$watch('l1',L1);
          });

          function L1(){
            var val = this.last;
            //console.log(val);

            if(angular.isDefined(val)){

              $scope[this.exp] = val;
              $scope.l2 = '';
              $scope.l3 = '';

              if(val === ''){
                $scope.status.l2 = true;
                $scope.status.l3 = true;

              }else{
                $scope.status.l2 = false;

                $timeout(function(){

                  var target = select.eq(0).find('option[value=\"'+ val +'\"]');
                  var query = target.attr('query');

                  // 判断query是区分数据不一致的情况:初始选项在接口返回的选项里可能不存在,其他函数里的query也是同样的作用
                  if(query){
                    CarModelService(query).then(function(data){

                      $scope.icon = target.attr('icon');
                      $scope.data.l2 = data;

                      if(!!initValue[1]){
                        $timeout(function(){
                          $scope.l2 = initValue[1];
                          initValue[1] = '';
                        });
                      }

                    },function(err){
                      console.log(err)
                    });

                  }else{
                    $scope.l1 = '';
                  }

                })
              }

              getValue()

            }
          }

          $timeout(function(){
            $scope.$watch('l2',L2);
          });

          function L2(){
            var val = this.last;

            if(angular.isDefined(val)){
              $scope.l3 = '';

              if(val === ''){
                $scope.status.l3 = true;

              }else{
                $scope.status.l3 = false;
                $timeout(function(){

                  var query = select.eq(1).find('[value='+ val +']').attr('query');

                  //console.log(query)

                  if(query){
                    CarModelService(query).then(function(data){

                      $scope.data.l3 = data;

                      if(!!initValue[2]) {
                        $timeout(function () {
                          var query = select.eq(2).find('[value=\"'+ initValue[2] +'\"]').val();
                          $scope.l3 = query ? initValue[2] : '';
                          initValue[2] = '';
                        })
                      }

                    },function(err){
                      //console.log(err)
                    })
                  }else{
                    $scope.l2 = '';
                  }

                })
              }

            }

            getValue()
          }

          $timeout(function(){
            $scope.$watch('l3',L3);
          });

          function L3(){
            var val = this.last;
            if(angular.isDefined(val)){
              $scope[this.exp] = val;
              getValue();
            }
          }

          /* 计算date,valid */
          function getValue() {

            var l1 = $scope.l1,
                l2 = $scope.l2,
                l3 = $scope.l3;

            if(l1 && l2 && l3){
              $scope.model = JSON.stringify([l1,l2,l3]);
              $scope.valid = true;
              $scope.showBubble = false;
            }else{
              $scope.model = '';
              $scope.valid = false;
            }


            if(!$scope.dirty){
              if(hasInitVal){
                  $timeout(function(){
                    $scope.dirty = true;
                  },800)
              }else if(l1 || l2 || l3){
                $scope.dirty = true;
              }
            }

            //console.log($scope.model,$scope.icon,$scope.valid);

          }
        }
      };
    });

  function sortFilter(data){
    var aReg = /[a-z]/i,
        obj = {},
        arr = [];

    data.forEach(function(val){
      var s = getSrotName(val.sortBy);
      if(!obj[s]) obj[s] = [];
      obj[s].push(val)
    });

    for(name in obj){
      var dl = obj[name];
      dl._sortKey = name;
      arr.push(dl)
    }

    arr.sort(function(n,m){
      return n._sortKey < m._sortKey ? -1 : 1;
    });

    function getSrotName (name){
      var a = name.charAt(0);
      return aReg.test(a) ? a.toUpperCase() : '#';
    }

    return arr;
  }

})();

/**
 * 图片验证码
 * eg
 * <div  mg-captcha=""
 *       captcha-url=""
 *       captcha-model=""
 *       account-model=""></div>
 *
 * */
(function () {

  angular
    .module('wedriveUsercenterWeb')
    .directive('mgCaptcha', mgCaptcha);

  /** @ngInject */
  function mgCaptcha() {
    return {
      replace : true,
      scope : {
        getCaptcha : '=mgCaptcha', //获取captcha Service
        captchaUrl : '=captchaUrl', //captchaUrl
        accountModel : '=', //账号model
        captchaModel : '=' //captcha model
      },
      require: '^^form',
      templateUrl: 'app/components/captcha/captcha.html',
      link: function (scope, element, attr, controller) {

        scope.account = controller[scope.accountName];
        scope.captchaUrl = '';

        scope.$watch('accountModel',function(val){

          if(val){
            scope.captchaUrl = scope.getCaptcha();
          }
        });

        scope.refreshCaptcha = function(){
          if(scope.captchaUrl){
            scope.captchaUrl = scope.getCaptcha();
            captchaInput.focus();
          }
        };

        var captchaInput = element.parents('form').find('input[name=captcha]');

        scope.$watch('captchaUrl',function(){

          scope.captchaModel = '';
        });
      }
    };
  }

})();

(function () {
    'use strict';
    //var FormData = Object;

    angular.module('WASCommon', [])
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.defaults.useXDomain = true;   // 发送CORS请求
            //$httpProvider.defaults.withCredentials = true;  // 请求携带Cookies
            //delete $httpProvider.defaults.headers.common['X-Requested-With'];
        }])

        .provider('RequestService', function () {//$rootScope
            var serviceUrl = '';

            function resultProcessor(result, success, failed) {
                success(result);
            }

            return {
                setServiceUrl : function (url) {
                    if (url) {
                        serviceUrl = url;
                    }
                },

                $get : function ($http, $q,$rootScope) {
                    function request(opts, processor) {
                        var d = $q.defer(),
                            url = serviceUrl + opts.url,
                            options = {
                                method : opts.method || 'GET',
                                url : url,
                                headers : opts.headers || {},
                                cache : typeof opts.cache === 'boolean' ? opts.cache : false,
                                withCredentials : angular.isUndefined(opts.withCredentials) ? true : opts.withCredentials
                            },
                            token = $rootScope.userInfo.token,
                            queryString, formData;

                        if(opts.token && token){
                            options.headers['X-Auth-Token'] = token;
                        }

                        if (options.method === 'POST') {
                            if (angular.isString(opts.data)) {
                                options.data = opts.data;

                                // 为了兼容接口，其实不应该这样实现
                                options.headers['Content-Type'] = 'application/json;charset=utf-8';
                            } else {
                                if (opts.data instanceof FormData) {
                                    options.data = opts.data;
                                } else {
                                    formData = new FormData();
                                    if (opts.data) {
                                        angular.forEach(opts.data, function (value, key) {
                                            formData.append(key, value);
                                        });
                                    }
                                    options.data = formData;
                                }
                                options.headers['Content-Type'] = undefined;
                                options.transformRequest = angular.identity;
                            }
                        } else if (options.method === 'GET') {
                            if (opts.data) {
                                queryString = $.param(opts.data);
                                options.url = url + (url.indexOf('?') > -1 ? '&' : '?') + queryString;
                            }
                        }

                        processor = processor || resultProcessor;

                        $http(options).then(function (res) {
                            //重定向判断登陆成功后，需再次请求接口（登陆验证成功会返回302状态码）
                            //if(res.data.code && res.data.code == '302'){
                            //    $http(angular.extend({},options,{cache : false})).then(function (res2) {
                            //        processor(res2.data, d.resolve, d.reject);
                            //    }, function (err) {
                            //        d.reject(err);
                            //    });
                            //}else{
                                processor(res.data, d.resolve, d.reject);
                            //}
                        }, function (err) {
                            d.reject(err);
                        });

                        return d.promise;
                    }

                    return {
                        get : function (options, processor) {
                            var data = options.data;
                            if (arguments.length === 1 && angular.isFunction(data)) {
                                processor = data;
                                data = null;
                            }
                            return request({
                                method : 'GET',
                                url : options.url,
                                data : data,
                                token : options.token,
                                cache : options.cache,
                                withCredentials : options.withCredentials
                            }, processor);
                        },

                        post : function (options, processor) {
                            var data = options.data;
                            if (angular.isFunction(data) && arguments.length === 1) {
                                processor = data;
                                data = null;
                            }
                            return request({
                                method : 'POST',
                                url : options.url,
                                data : data,
                                token : options.token,
                                headers : options.headers,
                                cache : options.cache,
                                withCredentials : options.withCredentials
                            }, processor);
                        },
                        request : request

                    };
                }
            };
        })
})();

(function () {
  'use strict';
  angular.module('WASCommon')
    .factory('requestInterceptor', requestInterceptor)
    .config(['$httpProvider', $httpProvider]);

  function requestInterceptor($rootScope,$cookies) {
    return {
      request : function (config) {
        return config;
      },
      response : function (response) {

        var token = response.headers('x-auth-token');
        token && $rootScope.$broadcast('user:logged_in',token);

        return response;
      },
      requestError : function (config) {
        return config;
      },
      responseError : function (data) {

        if(data && data.data && (data.data.code === 1027 || data.data.code === 1019 || data.data.code === 1018)){
          $rootScope.$broadcast('user:invalid');

          if(data.message){
            data.message = null;
          }
        }

        return data;
      }
    }
  }

  function $httpProvider($httpProvider) {
    $httpProvider.interceptors.push('requestInterceptor');
  }
})();

(function() {
  'use strict';

  angular
    .module('wedriveUsercenterWeb')
    .run(runBlock)
    .filter('mobileFilter',mobileFilter)
    .filter('emailFilter',emailFilter);

  /** @ngInject */
  function runBlock( $rootScope, $state, UserService, Toaster, $window, $location, settings) {
    $rootScope.product = $location.$$search.product || settings.product;

    $rootScope.toStatus = {};

    $rootScope.pattern = {
      mobile : '/^1\d{10}$/',
      email : '/^([a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+)$/i',
      account : '/^((1\d{10})|([a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+))$/i',
      password : '/^([\\w\\`\\~\\!\\@\\#\\$\\%\\^\\&\\*\\(\\)\\+\\-\\=\\{\\}\\|\\:\\"\\<\\>\\?\\[\\]\\\\\;\'\\,\\.\\/]{6,20})$/',
      smsCode : '/^\w{4,8}$/',
      captcha : '/^\w{4}$/',
      nickname : '/^[\w|\u4e00-\u9fa5]+$/',
      licence : '/^[0-9a-z]{6,10}$/i',
      engine : '/^\w{1,15}$/'
    };

    $rootScope.userInfo = {};
    $rootScope.logged = false;

    // 处理登录 info会在修改密码的时候直接传入token
    $rootScope.$on('user:logged_in', function(evt, info) {

      $rootScope.logged = true;

      if(angular.isString(info)){
        $rootScope.userInfo.token = info;

      }else{
        $rootScope.userInfo = info;

      }

    });

    // 处理退出登录
    $rootScope.$on('user:logged_out', function() {
      $rootScope.userInfo = {};
      $rootScope.logged = false;
      //delete $cookies.token;
      $state.go('noAccess.login');
    });

    // 处理强制退出登录
    var invalidTimer = null;
    $rootScope.$on('user:invalid', function() {
      clearTimeout(invalidTimer);
      invalidTimer = setTimeout(function(){
        Toaster.error('请重新登录');
        $rootScope.$broadcast('user:logged_out');
      },100);

    });

    $rootScope.$on('$stateChangeStart', function(evt, toState) {
      $rootScope.toStatus = toState;

      var name = toState.name || '';
      var route = name.split('.');



      if(route[0] === 'noAccess' && route[1] !== 'findPassword'){

        validateLogin(true);

      }else{

        if((route[0] === 'redirect' && route[1] !== 'weixinBind') || route[1] === 'findPassword'){
          /** 不需要权限 **/
          return;
        }

        validateLogin();
      }

    });

    //
    function validateLogin(goToHomePage){
      UserService.validateSSOLogin().then(function(data){
        $rootScope.$broadcast('user:logged_in',data.token);
        if($rootScope.redirectUrl){
          $window.location.href = decodeURIComponent($rootScope.redirectUrl);
        }else if(goToHomePage){
          $state.go('home');
        }else{
          getUserInfo();
        }

      },function(err){
        !goToHomePage && $rootScope.$broadcast('user:invalid');
      })
    }

    function getUserInfo(){
      UserService.getUserInfo().then(function(info){
        info.token = $rootScope.userInfo.token;
        $rootScope.$broadcast('user:logged_in',info);

      },function(){
        $rootScope.$broadcast('user:invalid');
      });
    }

    // 退出登录
    $rootScope.logout = function (useConfirm) {

      if(useConfirm){
        Toaster.confirm('确定退出登录吗?','提示',doLogout)
      }else{
        doLogout()
      }

      function doLogout(){
        UserService.ssoLogout().then(function () {

          //Toaster.success('退出登录成功');
          $rootScope.$broadcast('user:logged_out');

        }, function (data) {

          //退出登录后再次验证，是否登录
          UserService.validateSSOLogin().then(function(data){
            Toaster.error('退出登录失败');
          },function(err){
            $rootScope.$broadcast('user:logged_out');
          });

          // if(data.code === 1015){
          //
          // }else{
          //   Toaster.error('退出登录失败');
          // }

        })
      }

    };

    $rootScope.back = function() {
      $window.history.back();
    };

  }

  function mobileFilter(){
    return function(val){
      return !!val ? val.substring(0,3) + '******' + val.substring(9) : '未绑定';
    }
  }

  function emailFilter(){
    return function(val){
      var res = '';

      if(!!val){
        var mask = '****',
          header = val.split('@')[0],
          footer = val.split('@')[1],
          t1 = '',
          t2 = '';

        if(header.length > 3){
          t1 = header.substring(0,2);
          t2 = header.charAt(header.length - 1);
          res = t1 + mask + t2 + '@' + footer;

        }else if(header.length == 3){
          t1 = header.charAt(0);
          t2 = header.charAt(2);
          res = t1 + mask + t2 + '@' + footer;

        }else{
          t1 = header.charAt(0);
          res = t1 + mask + '@' + footer;
        }
      }

      return res;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('wedriveUsercenterWeb')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {

    $stateProvider

      /*--------- 未登录状态 ------------*/
      .state('noAccess', {
        //url: '/noAccess',
        templateUrl: 'app/views/noAccess/noAccess.html'
      })
      .state('noAccess.login', {
        url: '/login?:redirect:quickLogin:account',
        templateUrl: 'app/views/noAccess/login/login.html',
        title: '登录',
        controller : 'LoginController',
        controllerAs: 'login'
      })
      .state('noAccess.registerM', {
        url: '/registerM?:redirect',
        templateUrl: 'app/views/noAccess/registerM/registerM.html',
        title: '注册',
        controller : 'RegisterMController',
        controllerAs: 'registerM'
      })
      .state('noAccess.registerE', {
        url: '/registerE?:redirect',
        templateUrl: 'app/views/noAccess/registerE/registerE.html',
        title: '注册',
        controller : 'RegisterEController',
        controllerAs: 'registerE'
      })
      .state('noAccess.findPassword', {
        url: '/findPassword?:redirect',
        templateUrl: 'app/views/noAccess/findPassword/findPassword.html',
        title: '忘记密码',
        controller : 'FindPasswordController',
        controllerAs: 'findPassword'
      })

      /*--------- 主页 ------------*/
      .state('home', {
        url: '/',
        templateUrl: 'app/views/home/home.html',
        controller : 'HomeController',
        controllerAs: 'home'
      })

      /*--------- 账号安全 ------------*/
      .state('security', {
        //url: '/security',
        templateUrl: 'app/views/security/security.html',
        controller : 'SecurityController',
        controllerAs: 'security'
      })
      .state('security.updatePassword', {
        url: '/updatePassword',
        templateUrl: 'app/views/security/updatePassword/updatePassword.html',
        controller : 'UpdatePasswordController',
        controllerAs: 'updatePassword'
      })
      .state('security.bindMobile', {
        url: '/bindMobile',
        templateUrl: 'app/views/security/bindMobile/bindMobile.html',
        controller : 'BindMobileController',
        controllerAs: 'bindMobile'
      })
      .state('security.bindEmail', {
        url: '/bindEmail',
        templateUrl: 'app/views/security/bindEmail/bindEmail.html',
        controller : 'BindEmailController',
        controllerAs: 'bindEmail'
      })
      .state('security.bindThirdParty', {
        url: '/bindThirdParty',
        templateUrl: 'app/views/security/bindThirdParty/bindThirdParty.html',
        controller : 'BindThirdPartyController',
        controllerAs: 'bindThirdParty'
      })

      /*--------- 我的资料 ------------*/
      .state('profile', {
        //url: '/profile',
        templateUrl: 'app/views/profile/profile.html',
        controller : 'ProfileController',
        controllerAs: 'profile'
      })
      .state('profile.photo', {
        url: '/photo',
        templateUrl: 'app/views/profile/photo/photo.html',
        controller : 'PhotoController',
        controllerAs: 'photo'
      })
      .state('profile.basicInfo', {
        url: '/basicInfo',
        templateUrl: 'app/views/profile/basicInfo/basicInfo.html',
        controller : 'BasicInfoController',
        controllerAs: 'basicInfo'
      })
      .state('profile.car', {
        url: '/car',
        templateUrl: 'app/views/profile/car/car.html',
        controller : 'CarController',
        controllerAs: 'car'
      })
      .state('profile.nickname', {
        url: '/nickname',
        templateUrl: 'app/views/profile/nickname/nickname.html',
        controller : 'NicknameController',
        controllerAs: 'nickname'
      })

      /*--------- 重定向页 ------------*/
      .state('redirect', {
        //url: '/redirect',
        templateUrl: 'app/views/redirect/redirect.html'
      })
      .state('redirect.weixinLogin', {
        url: '/weixinLogin?:code:state',
        templateUrl: 'app/views/redirect/weixinLogin/weixinLogin.html',
        controller : 'WeixinLoginController',
        controllerAs: 'weixinLogin'
      })
      .state('redirect.weixinBind', {
        url: '/weixinBind?:code:state',
        templateUrl: 'app/views/redirect/weixinBind/weixinBind.html',
        controller : 'WeixinBindController',
        controllerAs: 'weixinBind'
      })
      .state('redirect.activateEmail', {
        url: '/activateEmail',
        templateUrl: 'app/views/redirect/activateEmail/activateEmail.html',
        controller : 'ActivateEmailController',
        controllerAs: 'activateEmail'
      })
    ;

    $urlRouterProvider.otherwise('/');

  }

})();

(function() {
  'use strict';

  angular
    .module('wedriveUsercenterWeb')
    .constant('settings', {
      product: 'webUser',
      weixin : {
        appid : 'wx06505edcacbd418a', //微信 appid
        openUrl : 'https://open.weixin.qq.com' //微信开放平台地址
      },
      // userCenterServiceUrl : 'http://10.10.51.79',          //万亮
      // userCenterServiceUrl : 'http://192.168.85.49',          //内网
      // userCenterServiceUrl : 'http://wdservice.mapbar.com', //外网
      userCenterServiceUrl : 'https://wecloudservice.autoai.com/passport', //外网
      // userCenterServiceUrl : 'http://117.107.204.165:8888/', //外网
      //userCenterServiceUrl : '/api',                               //代理

      //carModelServiceUrl : 'http://192.168.85.29:6533/obd_web_2.0' //内网
      carModelServiceUrl : 'https://obdms.mapbar.com/obd_web'       //外网
      //carModelServiceUrl : '/api/obd_web'                            //代理

    });
})();

(function() {
  'use strict';

  angular
    .module('wedriveUsercenterWeb')
    .config(config);

  /** @ngInject */
  function config($logProvider,UserServiceProvider,settings) {

    // Enable log
    $logProvider.debugEnabled(true);
    UserServiceProvider.setServiceUrl(settings.userCenterServiceUrl + '/user');

  }

})();

angular.module("wedriveUsercenterWeb").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/captcha/captcha.html","<div class=\"mg-captcha\" title=\"{{captchaUrl ? \'换一张\' : \'请先输入账号\'}}\"><img ng-show=\"captchaUrl\" ng-src=\"{{captchaUrl}}\" ng-click=\"refreshCaptcha()\"> <span>验证码</span></div>");
$templateCache.put("app/components/carModelSelector/carModelSelector.html","<select ng-model=\"l1\" ng-disabled=\"status.l1\"><option value=\"\">品牌</option><optgroup ng-repeat=\"gp in data.l1\" label=\"{{gp._sortKey}}\"><option ng-repeat=\"o in gp\" value=\"{{o.name}}\" icon=\"{{o.carIcon}}\" query=\"{{o.id}}\" ng-bind=\"o.name\"></option></optgroup></select>&nbsp;<select ng-model=\"l2\" ng-disabled=\"status.l2\"><option value=\"\">车型</option><option ng-repeat=\"o in data.l2\" value=\"{{o.name}}\" query=\"{{o.id}}\" ng-bind=\"o.name\"></option></select>&nbsp;<select ng-model=\"l3\" ng-disabled=\"status.l3\"><option value=\"\">年款</option><option ng-repeat=\"o in data.l3\" value=\"{{o.name}}\" ng-bind=\"o.name\"></option></select><div class=\"mg-form-message-bubble\" ng-if=\"bubble\" ng-show=\"(dirty && !valid) || showBubble\"><span class=\"glyphicon glyphicon-exclamation-sign color-error\" aria-hidden=\"true\"></span><div class=\"mg-bubble\"><i class=\"ico ico-error\"></i><span>{{bubble}}</span></div></div>");
$templateCache.put("app/components/closeWindowButton/closeWindowButton.html","<button class=\"button button-normal mt40\" ng-click=\"closeWindow()\">{{text}}({{cd}})</button>");
$templateCache.put("app/components/dateSelector/dateSelector.html","<select ng-model=\"year\" ng-disabled=\"status.y.disabled\" ng-init=\"\" ng-options=\"y as y for y in data.year\"><option value=\"\">年</option></select>&nbsp;<select ng-model=\"month\" ng-disabled=\"status.m.disabled\" ng-init=\"\" ng-options=\"m.value as m.value for m in data.month\"><option value=\"\">月</option></select>&nbsp;<select ng-model=\"day\" ng-disabled=\"status.d.disabled\" ng-init=\"\" ng-options=\"d.value as d.value for d in data.day\"><option value=\"\">日</option></select><div class=\"mg-form-message-bubble\" ng-if=\"dirty && !valid && bubble\" ng-show=\"delay\"><span class=\"glyphicon glyphicon-exclamation-sign color-error\" aria-hidden=\"true\"></span><div class=\"mg-bubble\"><i class=\"ico ico-error\"></i><span>{{bubble}}</span></div></div>");
$templateCache.put("app/components/header/header.html","<div id=\"header\" ng-if=\"!hidden\"><div class=\"header-content mainWidth bc\"><h1 class=\"logo\"><a ng-if=\"noAccess\" href=\"javascript:;\" class=\"link1\" ui-sref=\"noAccess.login({redirect:redirectUrl})\">WeCloud账号</a> <a ng-if=\"!noAccess\" href=\"javascript:;\" class=\"link1\" ui-sref=\"home\">WeCloud账号</a></h1><div ng-if=\"noAccess\"><p class=\"header-page\" ng-show=\"title !== \'登录\'\">{{title}}</p><div class=\"header-info\" ng-show=\"status === 0\"><a href=\"javascript:;\" class=\"link2 ml5\" ui-sref=\"noAccess.registerM({redirect:redirectUrl})\">免费注册</a></div><div class=\"header-info\" ng-show=\"status === 1\"><span>已有WeCloud账号？</span> <a href=\"javascript:;\" class=\"link2 ml5\" ui-sref=\"noAccess.login({redirect:redirectUrl})\">登录</a></div><div class=\"header-info\" ng-show=\"status === 2\"><a href=\"javascript:;\" class=\"link2\" ui-sref=\"noAccess.login({redirect:redirectUrl})\">登录</a> <a href=\"javascript:;\" class=\"link2 ml15\" ui-sref=\"noAccess.registerM({redirect:redirectUrl})\">注册</a></div></div><div ng-if=\"!noAccess\"><ul class=\"header-navi\"><li><a href=\"javascript:;\" class=\"link2\" ng-class=\"{active: top === \'home\'}\" ui-sref=\"home\">首页</a></li><li><a href=\"javascript:;\" class=\"link2\" ng-class=\"{active: top === \'security\'}\" ui-sref=\"security.updatePassword\">账号安全</a></li><li><a href=\"javascript:;\" class=\"link2\" ng-class=\"{active: top === \'profile\'}\" ui-sref=\"profile.photo\">我的资料</a></li></ul><div class=\"header-info\"><span>{{userInfo.nickname || (userInfo.email | emailFilter) || (userInfo.mobile | mobileFilter)}}</span> <a href=\"javascript:;\" class=\"link1 ml5\" ng-click=\"logout(true)\">[退出]</a></div></div></div></div>");
$templateCache.put("app/components/input/input.html","<div ng-transclude=\"\"></div><i class=\"mg-input-ico mg-input-text\" ng-show=\"_value || value\" ng-click=\"clear()\"></i> <i class=\"mg-input-ico mg-input-password\" ng-show=\"_value || value\" ng-mousedown=\"showPassword()\" ng-mouseup=\"hidePassword()\"></i>");
$templateCache.put("app/components/message/message.html","<div ng-show=\"model.$invalid || isInfoShow\"><div class=\"mg-form-message-bubble\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\" ng-show=\"isInfoShow || (!focused && model.$viewValue && model.$invalid) || (!focused && submitted && model.$invalid)\" ng-mouseenter=\"showBubble = true\" ng-mouseleave=\"showBubble = false\" ng-class=\"{\'color-error\' : !focused && model.$invalid && (model.$viewValue || submitted)}\"></span><div class=\"mg-bubble\" ng-show=\"(isInfoShow && focused) || (!focused && model.$viewValue && model.$invalid) || showBubble || (!focused && submitted && model.$invalid)\"><i class=\"ico ico-error\"></i> <span ng-transclude=\"\" ng-show=\"!focused && (model.$viewValue || (!focused && submitted && model.$invalid))\"></span><div class=\"mg-bubble-message-info\"></div></div></div></div>");
$templateCache.put("app/components/provinceSelector/provinceSelector.html","<select ng-model=\"province\" class=\"form-select\"><optgroup ng-repeat=\"gp in data\" label=\"{{gp._sortKey}}\"><option ng-repeat=\"p in gp\">{{p.name}}</option></optgroup></select>");
$templateCache.put("app/components/regionSelector/regionSelector.html","<select ng-model=\"province\" ng-show=\"status.p.show\" ng-disabled=\"status.p.disabled\"><option value=\"\">请选择省</option><option ng-repeat=\"p in data.province\" value=\"{{p.name}}\" data-index=\"{{p.id}}\">{{p.name}}</option></select>&nbsp;<select ng-model=\"city\" ng-show=\"status.c.show\" ng-disabled=\"status.c.disabled\"><option value=\"\">请选择市</option><option ng-repeat=\"c in data.city\" value=\"{{c.name}}\" data-index=\"{{c.id}}\">{{c.name}}</option></select>&nbsp;<select ng-model=\"district\" ng-show=\"status.d.show\" ng-disabled=\"status.d.disabled\"><option value=\"\">请选择区</option><option ng-repeat=\"d in data.district\" value=\"{{d.name}}\">{{d.name}}</option></select><div class=\"mg-form-message-bubble\" ng-if=\"dirty && !valid && bubble\"><span class=\"glyphicon glyphicon-exclamation-sign color-error\" aria-hidden=\"true\"></span><div class=\"mg-bubble\"><i class=\"ico ico-error\"></i><span>{{bubble}}</span></div></div>");
$templateCache.put("app/components/sidebar/sidebar.html","<div id=\"sidebar\"><ul><li ng-repeat=\"li in data\"><a href=\"javascript:;\" ui-sref=\"{{li.href}}\" ng-class=\"{active: li.href === active}\" ng-if=\"li.hide !== true\"><i class=\"ico\" ng-class=\"li.ico\"></i> <span>{{li.title}}</span></a></li></ul></div>");
$templateCache.put("app/views/home/home.html","<div id=\"content\"><div class=\"mainWidth bc\" ng-if=\"userInfo&&userInfo.userId\"><div id=\"main\" class=\"cf\"><div class=\"index-main mt30\"><div class=\"cf\"><a href=\"javascript:;\" class=\"index-photo fl\" ui-sref=\"profile.photo\"><img mg-photo=\"\" ng-src=\"{{home.userPhotoUrl}}\"><p>修改头像</p></a> <a href=\"javascript:;\" class=\"fl ml15 mt40\" ng-if=\"!userInfo.nickname\" ui-sref=\"profile.nickname\">取个昵称吧</a><p class=\"fl ml15 mt40 index-nickname\" ng-if=\"userInfo.nickname\" ng-click=\"home.alertNickname()\">{{userInfo.nickname}}</p></div><h2 class=\"title mt50\">密保绑定</h2><p class=\"mt15\" ng-if=\"!userInfo.mobile\"><i class=\"ico ico-warn index-bindIco\"></i> <span>绑定手机</span> <span class=\"ml15\">未绑定</span> <span class=\"col-light ml15\">可用于登录WeCloud账号和找回密码，安全有保障</span> <button class=\"button-confirm button-normal ml15\" ui-sref=\"security.bindMobile\">立即绑定</button></p><p class=\"mt15\" ng-if=\"userInfo.mobile\"><i class=\"ico ico-success index-bindIco\"></i> <span>绑定手机</span> <span class=\"col-light ml15\">已绑定</span> <span class=\"col-light ml15\">可用于登录WeCloud账号和找回密码，安全有保障</span></p><p class=\"mt15\" ng-if=\"!userInfo.email\"><i class=\"ico ico-warn index-bindIco\"></i> <span>绑定邮箱</span> <span class=\"ml15\">未绑定</span> <span class=\"col-light ml15\">可用于登录WeCloud账号和找回密码，账号更安全</span> <button class=\"button-confirm button-normal ml15\" ui-sref=\"security.bindEmail\">立即绑定</button></p><p class=\"mt15\" ng-if=\"userInfo.email\"><i class=\"ico ico-success index-bindIco\"></i> <span>绑定邮箱</span> <span class=\"col-light ml15\">已绑定</span> <span class=\"col-light ml15\">可用于登录WeCloud账号和找回密码，账号更安全</span></p><h2 class=\"title mt50\">登录历史</h2><div ng-if=\"home.loginHistory.data\"><p class=\"mt15 col-light\">以下是您1个月内最近{{home.loginHistory.data.length}}次的登录情况，若存在异常登录记录，请在核实后尽快修改密码</p><div class=\"table mt20\"><table><thead><tr><th>日期</th><th>IP</th><th>城市</th><th>设备</th></tr></thead><tbody><tr ng-repeat=\"h in home.loginHistory.data\" ng-show=\"$index < 4 || home.loginHistory.more === true\"><td>{{h.loginTime}}</td><td>{{h.ip}}</td><td>{{h.city}}</td><td>{{h.device}}</td></tr></tbody></table><div ng-if=\"home.loginHistory.data.length > 4\"><div class=\"table-btn\" ng-show=\"!home.loginHistory.more\" ng-click=\"home.loginHistory.more = true\"><span>显示更多</span> <i class=\"ico ico-arrow-down\"></i></div><div class=\"table-btn\" ng-show=\"home.loginHistory.more\" ng-click=\"home.loginHistory.more = false\"><span>收起更多</span> <i class=\"ico ico-arrow-up\"></i></div></div></div></div><p ng-if=\"!home.loginHistory.data && home.loginHistory.data !== undefined\" class=\"mt15 col-light\">无记录</p><p ng-if=\"home.loginHistory.data === undefined\" class=\"mt15 col-light\">加载中...</p></div><div class=\"index-sidebar mt30\"><h2 class=\"title\">常用操作</h2><ul><li class=\"cf\"><i class=\"ico ico-password2\"></i><div><p>登录密码<a href=\"javascript:;\" class=\"fr\" ui-sref=\"security.updatePassword\">[修改]</a></p><p><span class=\"col-light\">定期改密码，账号更安全</span></p></div></li><li class=\"cf\"><i class=\"ico ico-mobile2\"></i><div><div ng-if=\"!userInfo.mobile\"><p>绑定手机 <a href=\"javascript:;\" class=\"fr\" ui-sref=\"security.bindMobile\">[绑定]</a></p><span class=\"col-warn\">未设置</span></div><div ng-if=\"userInfo.mobile\"><p>绑定手机 <a href=\"javascript:;\" class=\"fr\" ui-sref=\"security.bindMobile\">[修改]</a></p><em class=\"col-light\">{{userInfo.mobile | mobileFilter}}</em></div></div></li><li class=\"cf\"><i class=\"ico ico-email2\"></i><div><div ng-if=\"!userInfo.email\"><p>绑定邮箱 <a href=\"javascript:;\" class=\"fr\" ui-sref=\"security.bindEmail\">[绑定]</a></p><span class=\"col-warn\">未设置</span></div><div ng-if=\"userInfo.email\"><p>绑定邮箱 <a href=\"javascript:;\" class=\"fr\" ui-sref=\"security.bindEmail\">[修改]</a></p><em class=\"col-light\">{{userInfo.email | emailFilter}}</em></div></div></li></ul></div></div></div></div>");
$templateCache.put("app/views/noAccess/noAccess.html","<div id=\"content\"><div class=\"mainWidth bc\"><div id=\"no-access-content\"><div class=\"filler\"></div><div data-ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/views/profile/profile.html","<div id=\"content\"><div class=\"mainWidth bc\"><div id=\"main\" class=\"hasSidebar\"><div id=\"main-content\"><div data-ui-view=\"\"></div></div></div><div mg-sidebar=\"profile.sidebar\" active=\"toStatus.name\"></div></div></div>");
$templateCache.put("app/views/redirect/redirect.html","<div data-ui-view=\"\"></div>");
$templateCache.put("app/views/security/security.html","<div id=\"content\"><div class=\"mainWidth bc\"><div id=\"main\" class=\"hasSidebar\"><div id=\"main-content\"><div data-ui-view=\"\"></div></div></div><div mg-sidebar=\"security.sidebar\" active=\"toStatus.name\"></div></div></div>");
$templateCache.put("app/views/noAccess/findPassword/findPassword.html","<div class=\"box findPassword-box bc\" ng-class=\"{0:\'p1\',1:\'p2\',2:\'p3\'}[findPassword.view]\"><div class=\"findPassword-progress\"><ul><li class=\"pp1\">输入账号</li><li class=\"pp2\">验证账号</li><li class=\"pp3\">重置密码</li></ul><div class=\"progress-bar bc\"></div></div><form class=\"form mt30 ff1\" name=\"findPassword.account_form\" ng-submit=\"findPassword.checkAccount(findPassword.account_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table><tbody><tr><td class=\"form-label\">账号</td><td colspan=\"2\" mg-input=\"findPassword.paramsAccount.account\"><input class=\"form-control\" type=\"text\" placeholder=\"注册时所填手机/邮箱\" name=\"account\" ng-model=\"findPassword.paramsAccount.account\" ng-pattern=\"/^((1\\d{10})|([a-z0-9]+([._\\\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+))$/i\" required=\"\" autofocus=\"\"><div as-messages=\"account\"><div as-message=\"required\">请输入账号</div><div as-message=\"pattern\">账号格式不正确</div></div></td></tr><tr><td class=\"form-label\" style=\"width: 60px;\">验证码</td><td><input class=\"form-control\" type=\"text\" placeholder=\"图形验证码\" name=\"captcha\" ng-model=\"findPassword.paramsAccount.captcha\" ng-pattern=\"/^\\w{4}$/\" required=\"\"></td><td style=\"width: 100px; padding-left: 10px;\"><div mg-captcha=\"findPassword.getCaptcha\" captcha-url=\"findPassword.captchaUrl\" captcha-model=\"findPassword.paramsAccount.captcha\" account-model=\"findPassword.paramsAccount.account\"></div><div as-messages=\"captcha\"><div as-message=\"required\">请输入验证码</div><div as-message=\"pattern\">验证码错误</div></div></td></tr><tr><td class=\"form-label\" style=\"padding-top: 20px;\"></td><td colspan=\"2\"><button type=\"submit\" class=\"button-confirm button-long\" ng-disabled=\"findPassowrd.account_form.$submitted\">下一步</button></td></tr></tbody></table></form><div ng-if=\"findPassword.view == 1\"><form class=\"form mt30 ff2\" name=\"findPassword.check_form\" ng-submit=\"findPassword.checkVerifyCode(findPassword.check_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><p class=\"tc ml10\">已发送{{findPassword.paramsAccount.type === \'mobile\' ? \'短信\' : \'邮箱\'}}验证码到</p><p class=\"tc ml10 findPassword-account\">{{findPassword.paramsAccount.account}}</p><p class=\"mt20\"></p><table><tbody><tr><td class=\"form-label\" style=\"width: 60px;\">验证码</td><td><input class=\"form-control\" type=\"text\" placeholder=\"{{findPassword.paramsAccount.type === \'mobile\' ? \'短信\' : \'邮箱\'}}验证码\" name=\"varifyCode\" ng-model=\"findPassword.verifyCode\" ng-pattern=\"/^\\w{4,8}$/\" required=\"\"></td><td style=\"width: 100px; padding-left: 10px;\"><button type=\"submit\" class=\"button button-long\" mg-vcode-button=\"findPassword.vcodeOptions\">发送验证码</button><div as-messages=\"varifyCode\"><div as-message=\"required\">请输入验证码</div><div as-message=\"pattern\">验证码错误</div></div></td></tr><tr><td class=\"form-label\" style=\"padding-top: 20px;\"></td><td colspan=\"2\"><button class=\"button-confirm button-long\" ng-disabled=\"findPassowrd.check_form.$submitted\">下一步</button></td></tr></tbody></table></form></div><form class=\"form mt30 ff3\" name=\"findPassword.reset_form\" ng-submit=\"findPassword.resetPassword(findPassword.reset_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table><tbody><tr><td class=\"form-label\" style=\"width: 60px;\">新密码</td><td mg-input=\"findPassword.newPassword\"><input class=\"form-control\" type=\"password\" placeholder=\"6~20位，建议数组、字母、符号组合\" name=\"newPassword\" ng-model=\"findPassword.newPassword\" ng-pattern=\"{{pattern.password}}\" required=\"\"><div as-messages=\"newPassword\"><div as-message=\"pattern\">6~20位，建议数组、字母、符号组合</div><div as-message=\"required\">请输入密码</div></div></td></tr><tr><td class=\"form-label\" style=\"padding-top: 20px;\"></td><td><button class=\"button-confirm button-long\" ng-disabled=\"findPassowrd.reset_form.$submitted\">确定</button></td></tr></tbody></table></form></div>");
$templateCache.put("app/views/noAccess/login/login.html","<div class=\"login-banner\"></div><div class=\"box login-box\"><div class=\"login-title\"><a href=\"javascript:;\" ng-class=\"{active : login.loginType === 0}\" ng-click=\"login.loginType = 0\">普通方式登录 <i class=\"arrow\"></i></a> <a href=\"javascript:;\" ng-class=\"{active : login.loginType === 1}\" ng-click=\"login.loginType = 1\">手机快捷登录 <i class=\"arrow\"></i></a></div><form ng-show=\"login.loginType === 0\" class=\"login-form\" name=\"login.login_form\" ng-submit=\"login.submitNormal(login.login_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><div class=\"icon-input\" mg-input=\"login.paramsNormal.loginName\"><em class=\"ico ico-photo\"></em> <input class=\"form-control\" type=\"text\" placeholder=\"手机/邮箱\" name=\"loginName\" ng-model=\"login.paramsNormal.loginName\" ng-pattern=\"/^((1\\d{10})|([a-z0-9]+([._\\\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+))$/i\" required=\"\"><div as-messages=\"loginName\"><div as-message=\"required\">请输入手机或邮箱</div><div as-message=\"pattern\">账号格式不正确</div></div></div><div class=\"icon-input mt20\" mg-input=\"login.paramsNormal.password\"><em class=\"ico ico-password\"></em> <input class=\"form-control\" type=\"password\" placeholder=\"密码\" name=\"password\" ng-model=\"login.paramsNormal.password\" ng-pattern=\"{{pattern.password}}\" required=\"\"><div as-messages=\"password\"><div as-message=\"required\">请输入密码</div><div as-message=\"pattern\">密码错误</div></div></div><div class=\"icon-input mt20 cf\" ng-show=\"login.requiredCaptha\"><em class=\"ico ico-code\"></em> <input class=\"form-control\" type=\"text\" placeholder=\"图形验证码\" style=\"width: 66%\" name=\"captcha\" ng-model=\"login.paramsNormal.captcha\" ng-pattern=\"/.{4}/\" ng-required=\"login.requiredCaptha\"><div mg-captcha=\"login._getCaptcha\" captcha-url=\"login.captchaUrl\" captcha-model=\"login.paramsNormal.captcha\" account-model=\"login.paramsNormal.loginName\"></div><div as-messages=\"captcha\"><div as-message=\"required\">请输入验证码</div><div as-message=\"pattern\">验证码错误</div></div></div><div class=\"mt15 cf\"><label class=\"fl\"><input type=\"checkbox\" ng-model=\"login.paramsNormal.autoLogin\"> <span>下次自动登录</span></label> <a href=\"javascript:;\" class=\"fr\" ui-sref=\"noAccess.findPassword({redirect:redirectUrl})\">忘记密码？</a></div><button type=\"submit\" class=\"button-confirm button-long mt15\" ng-disabled=\"login.login_form.$submitted\">登录</button></form><form ng-show=\"login.loginType === 1\" class=\"login-form\" name=\"login.quickLogin_form\" ng-submit=\"login.submitQuick(login.quickLogin_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><div class=\"icon-input\" mg-input=\"login.paramsQuick.mobile\"><em class=\"ico ico-mobile\"></em> <input class=\"form-control\" type=\"text\" placeholder=\"手机\" name=\"loginMobile\" ng-model=\"login.paramsQuick.mobile\" ng-pattern=\"/^1\\d{10}$/\" required=\"\"><div as-messages=\"loginMobile\"><div as-message=\"required\">请输入手机</div><div as-message=\"pattern\">手机格式不正确</div></div></div><div class=\"icon-input mt20 cf\"><em class=\"ico ico-code\"></em> <input class=\"form-control\" type=\"text\" placeholder=\"短信验证码\" style=\"width: 66%\" name=\"loginSmsCode\" ng-model=\"login.paramsQuick.smsCode\" ng-pattern=\"/^\\w+$/\" required=\"\"> <button type=\"button\" class=\"button button-normal fr\" mg-vcode-button=\"login.smsCodeOptions\">获取验证码</button><div as-messages=\"loginSmsCode\"><div as-message=\"required\">请输入短信验证码</div><div as-message=\"pattern\">短信验证码不正确</div></div></div><div class=\"mt15 cf\"><label class=\"fl\"><input type=\"checkbox\" ng-model=\"login.paramsQuick.autoLogin\"> <span>下次自动登录</span></label> <a href=\"javascript:;\" class=\"fr\" ui-sref=\"noAccess.findPassword({redirect:redirectUrl})\">忘记密码？</a></div><button type=\"submit\" class=\"button-confirm button-long mt15\" ng-disabled=\"login.quickLogin_form.$submitted\">登录</button><p class=\"mt15\">提示：未注册的手机登录，将自动创建账号，且代表您已同意接受 <a href=\"javascript:;\" ng-click=\"terms.open = true\">隐私政策和服务条款</a> 。</p></form></div><div class=\"cb\"></div>");
$templateCache.put("app/views/noAccess/registerE/registerE.html","<div ng-if=\"registerE.view === 0\" class=\"box register-box bc\"><p class=\"register-title\">一次注册 畅行WeCloud各平台产品</p><form class=\"form\" name=\"registerE.next_form\" ng-submit=\"registerE.next(registerE.next_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table><tbody><tr><td class=\"form-label\">邮箱</td><td colspan=\"2\" mg-input=\"registerE.model.email\"><input class=\"form-control\" type=\"text\" placeholder=\"常用邮箱\" ng-blur=\"registerE.vacant()\" name=\"email\" ng-model=\"registerE.model.email\" ng-pattern=\"/^([a-z0-9]+([._\\\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+)$/i\" required=\"\" autofocus=\"\"><div as-messages=\"email\"><div as-message=\"required\">请输入邮箱</div><div as-message=\"pattern\">邮箱地址错误</div></div></td></tr><tr><td class=\"form-label\">密码</td><td colspan=\"2\" mg-input=\"registerE.model.password\"><input class=\"form-control\" type=\"password\" placeholder=\"6~20位，建议数字、字母、符号组合\" name=\"password\" ng-model=\"registerE.model.password\" ng-pattern=\"{{pattern.password}}\" required=\"\"><div as-messages=\"password\"><div as-message=\"pattern\">6~20位，建议数字、字母、符号组合</div><div as-message=\"required\">请输入密码</div></div></td></tr><tr><td class=\"form-label\" style=\"width: 60px;\">验证码</td><td><input class=\"form-control\" type=\"text\" placeholder=\"图形验证码\" name=\"captcha\" ng-model=\"registerE.model.captcha\" ng-pattern=\"/^\\w{4}$/\" required=\"\"></td><td style=\"width: 100px; padding-left: 10px;\"><div mg-captcha=\"registerE.getCaptcha\" captcha-url=\"registerE.captchaUrl\" captcha-model=\"registerE.model.captcha\" account-model=\"registerE.model.email\"></div><div as-messages=\"captcha\"><div as-message=\"required\">请输入验证码</div><div as-message=\"pattern\">验证码错误</div></div></td></tr><tr><td class=\"form-label\" style=\"height: 26px;\"></td><td colspan=\"2\" style=\"height: 26px;\"><p style=\"margin-top: -20px;\">注册视为同意 <a href=\"javascript:;\" ng-click=\"terms.open = true\">隐私政策和服务条款</a></p></td></tr><tr><td class=\"form-label\"></td><td colspan=\"2\"><button type=\"submit\" ng-disabled=\"registerE.next_form.$submitted\" class=\"button-confirm button-long\">注册</button></td></tr></tbody></table></form></div><div ng-if=\"registerE.view === 1\" class=\"box register-box2 bc tc\"><p class=\"register-title\"><i></i>还差一步，完成注册！</p><p class=\"mt20\">一封激活邮件已发送到您的注册邮箱：</p><p class=\"register-account\">{{registerE.model.email}}</p><p>请点击邮件中的链接完成注册！</p><a href=\"{{registerE.emailURL}}\" target=\"_blank\" class=\"button-confirm button-long bc mt25\" style=\"width: 90%;\">去邮箱收信</a><form class=\"register-info\"><div style=\"margin-top: -12px;\"></div><p>没有收到确认邮件？</p><br><div class=\"mt20\">是否在邮箱的垃圾邮件或回收站中</div><div>重新发送，<button mg-vcode-button=\"registerE.verifyCodeOptions\" type=\"button\" class=\"inline-button\" href=\"javascript:;\">点此重新发一封</button></div></form></div><p style=\"width: 380px;\" class=\"bc mt15 tr\"><a href=\"javascript:;\" ui-sref=\"noAccess.registerM({redirect:redirectUrl})\">通过手机注册>></a></p>");
$templateCache.put("app/views/noAccess/registerM/registerM.html","<div ng-if=\"registerM.view === 0\" class=\"box register-box bc\"><p class=\"register-title\">一次注册 畅行WeCloud各平台产品</p><form class=\"form\" name=\"registerM.next_form\" ng-submit=\"registerM.next(registerM.next_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table><tbody><tr><td class=\"form-label\">手机</td><td colspan=\"2\" mg-input=\"registerM.model.mobile\"><input class=\"form-control\" type=\"text\" placeholder=\"手机\" ng-blur=\"registerM.vacant()\" name=\"mobile\" ng-model=\"registerM.model.mobile\" ng-pattern=\"/^1\\d{10}$/\" required=\"\" autofocus=\"\"><div as-messages=\"mobile\"><div as-message=\"required\">请输入手机</div><div as-message=\"pattern\">手机格式不正确</div></div></td></tr><tr><td class=\"form-label\">密码</td><td colspan=\"2\" mg-input=\"registerM.model.password\"><input class=\"form-control\" type=\"password\" placeholder=\"6~20位，建议数字、字母、符号组合\" name=\"password\" ng-model=\"registerM.model.password\" ng-pattern=\"{{pattern.password}}\" required=\"\"><div as-messages=\"password\"><div as-message=\"required\">请输入密码</div><div as-message=\"pattern\">6~20位，建议数字、字母、符号组合</div></div></td></tr><tr><td class=\"form-label\" style=\"width: 60px;\">验证码</td><td><input class=\"form-control\" type=\"text\" placeholder=\"图形验证码\" name=\"captcha\" ng-model=\"registerM.model.captcha\" ng-pattern=\"/^\\w{4}$/\" required=\"\"></td><td style=\"width: 100px; padding-left: 10px;\"><div mg-captcha=\"registerM.getCaptcha\" captcha-url=\"registerM.captchaUrl\" captcha-model=\"registerM.model.captcha\" account-model=\"registerM.model.mobile\"></div><div as-messages=\"captcha\"><div as-message=\"required\">请输入验证码</div><div as-message=\"pattern\">验证码错误</div></div></td></tr><tr><td class=\"form-label\" style=\"height: 26px;\"></td><td colspan=\"2\" style=\"height: 26px;\"><p style=\"margin-top: -20px;\">注册视为同意 <a href=\"javascript:;\" ng-click=\"terms.open = true\">隐私政策和服务条款</a></p></td></tr><tr><td class=\"form-label\"></td><td colspan=\"2\"><button type=\"submit\" ng-disabled=\"registerM.next_form.$submitted\" class=\"button-confirm button-long\">注册</button></td></tr></tbody></table></form></div><div ng-if=\"registerM.view === 1\" class=\"box register-box bc\"><p class=\"tc ml15\">{{registerM.smsCodeSent ? \'已发送短信验证码到\' : \'请完成身份验证\'}}</p><p class=\"register-account tc ml15\">{{registerM.model.mobile}}</p><form class=\"form mt20\" name=\"registerM.register_form\" ng-submit=\"registerM.register(registerM.register_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table><tbody><tr><td class=\"form-label\" style=\"width: 60px;\">验证码</td><td><input class=\"form-control\" type=\"text\" placeholder=\"短信验证码\" name=\"smsCode\" ng-model=\"registerM.model.smsCode\" ng-pattern=\"/^\\w{4,8}$/\" required=\"\" autofocus=\"\"></td><td style=\"width: 100px; padding-left: 10px;\"><button class=\"button button-long\" mg-vcode-button=\"registerM.smsCodeOptions\">发送验证码</button><div as-messages=\"smsCode\"><div as-message=\"required\">请输入短信验证码</div><div as-message=\"pattern\">短信验证码不正确</div></div></td></tr><tr><td class=\"form-label\" style=\"padding-top: 15px;\"></td><td colspan=\"2\" style=\"padding-top: 15px;\"><button type=\"submit\" class=\"button-confirm button-long\" ng-disabled=\"registerM.next_form.$submitted\">完成</button></td></tr></tbody></table></form></div><p style=\"width: 380px;\" class=\"bc mt15 tr\"><a href=\"javascript:;\" ui-sref=\"noAccess.registerE(({redirect:redirectUrl}))\">通过邮箱注册>></a></p>");
$templateCache.put("app/views/profile/basicInfo/basicInfo.html","<h2 class=\"title\">基本资料</h2><form class=\"form mt30 basicInfo\" name=\"basicInfo.info_form\" ng-submit=\"basicInfo.updateUserInfo(basicInfo.info_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table style=\"width: 500px;\"><tbody><tr><td class=\"form-label\" style=\"width: 60px;\">性别</td><td><label><input name=\"gender\" type=\"radio\" value=\"1\" ng-model=\"basicInfo.options.gender\"> 男</label> <label><input name=\"gender\" type=\"radio\" value=\"0\" ng-model=\"basicInfo.options.gender\" class=\"ml20\"> 女</label></td></tr><tr><td class=\"form-label\">生日</td><td><div class=\"form-selects\" mg-date-selector=\"basicInfo.options.birthday\" valid=\"basicInfo.birthdayValid\" bubble=\"完整选择日期,本项才会保存\"></div></td></tr><tr><td class=\"form-label\">居住地</td><td><div class=\"form-selects\" mg-region-selector=\"\" province=\"basicInfo.options.liveProvince\" city=\"basicInfo.options.liveCity\" district=\"basicInfo.options.liveDistrict\" change=\"basicInfo.changeRegion\" valid=\"basicInfo.regionValid\" bubble=\"完整选择居住地,本项才会保存\"></div></td></tr><tr><td class=\"form-label\"></td><td colspan=\"2\"><button type=\"submit\" class=\"button-confirm button-normal\" ng-disabled=\"basicInfo.info_form.$submitted\">保存</button></td></tr></tbody></table></form>");
$templateCache.put("app/views/profile/car/car.html","<h2 class=\"title\">我的爱车</h2><div class=\"mt20\"><button class=\"button-confirm button\" ng-click=\"car.addCar()\">添加一辆爱车</button> <span class=\"ml10\" ng-if=\"!car.myCar.length\">你的车库空空如也，快来添加一辆爱车吧</span></div><div class=\"table mt30\" ng-if=\"car.myCar.length\" style=\"padding: 0\"><table><tbody><tr ng-repeat=\"c in car.myCar\"><td style=\"width: 84px;padding-left:20px;\"><img class=\"table-logo\" ng-src=\"{{c.carIcon}}\"></td><td style=\"padding: 0\"><table style=\"border-left: 1px solid #e4eaec;border-right: 1px solid #e4eaec;\"><tr style=\"border-top: 0\"><td width=\"108px;\">型号:</td><td colspan=\"3\">{{c.carModelId | carModelFilter}}</td></tr><tr><td>车牌号:</td><td>{{c.lisenceNo || \'无\'}}</td><td>购车日期:</td><td>{{(c.carBuyDate | dateFilter) || \'无\'}}</td></tr><tr><td>发动机号:</td><td>{{c.engineNo || \'无\'}}</td><td>车架号:</td><td>{{c.vin || \'无\'}}</td></tr></table></td><td class=\"noWarp\" style=\"width: 70px;\"><a href=\"javascript:;\" ng-click=\"car.editCar(c.carId)\">编辑</a> &nbsp; <a href=\"javascript:;\" ng-click=\"car.removeCar(c.carId)\">删除</a></td></tr></tbody></table></div><div dialog=\"\" modal=\"\" ng-if=\"car.dialog.open\" close=\"car.dialog.open = false\"><div dialog-title=\"\">{{car.dialog.type === \'add\' ? \'添加车辆\' : car.dialog.type === \'edit\' ? \'编辑车辆\' : \'\'}}</div><div dialog-content=\"\" style=\"min-width: 480px;\"><form class=\"form mt10\" ng-class=\"{\'car-license-on\':car.dialog.status === 1}\" name=\"car.edit_form\" ng-submit=\"car.submitDialog(car.edit_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table style=\"width: 96%\"><tbody><tr><td class=\"form-label\" style=\"width: 70px;\"><i class=\"col-error\">*</i>车型信息</td><td colspan=\"2\"><div class=\"car-selectors form-selects\" mg-car-model-selector=\"car.aCar.carModel\" icon=\"car.aCar.icon\" valid=\"car.aCar.carModelValid\" show-bubble=\"car.aCar.carModelshowBubble\" bubble=\"请完整选择车型信息\"></div></td></tr><tr><td class=\"form-label\">车牌</td><td colspan=\"2\" mg-input=\"car.aCar.licence\"><div mg-province-selector=\"car.aCar.province\" class=\"car-licence-select\"></div><input class=\"form-control car-licence-input\" type=\"text\" placeholder=\"请输入车牌号\" name=\"licence\" ng-model=\"car.aCar.licence\" ng-pattern=\"/^[0-9a-z]{0,10}$/i\" ng-minlength=\"6\" mg-text-transform=\"uppercase\"><div as-messages=\"licence\"><div as-message=\"pattern\">车牌号错误</div><div as-message=\"minlength\">车牌号至少6位</div></div></td></tr><tr><td class=\"form-label\">发动机号</td><td colspan=\"2\"><input class=\"form-control\" type=\"text\" placeholder=\"请输入发动机号\" name=\"engine\" ng-model=\"car.aCar.engine\" ng-pattern=\"/^\\w{1,15}$/\" mg-text-transform=\"uppercase\"><div as-messages=\"engine\"><div as-message=\"pattern\">发动机号错误</div></div><i class=\"ico ico-help car-icon-help\" title=\"发动机号示意图\" ng-click=\"car.dialog.status = 1\"></i></td></tr><tr><td class=\"form-label\">车架号</td><td colspan=\"2\"><input class=\"form-control\" type=\"text\" placeholder=\"请输入车架号\" name=\"vin\" ng-model=\"car.aCar.vin\" ng-pattern=\"/^\\w{1,17}$/\" maxlength=\"17\" mg-text-transform=\"uppercase\"><div as-messages=\"vin\"><div as-message=\"pattern\">车架号错误</div></div><i class=\"ico ico-help car-icon-help\" title=\"车架号示意图\" ng-click=\"car.dialog.status = 1\"></i></td></tr><tr><td class=\"form-label\" style=\"width: 70px;\">购车日期</td><td colspan=\"2\"><div class=\"car-selectors form-selects\" mg-date-selector=\"car.aCar.date\" valid=\"car.aCar.dateValid\" bubble=\"完整选择日期,本项才会保存\"></div></td></tr><tr><td class=\"form-label\"></td><td colspan=\"2\"><button class=\"button-confirm button-long\" type=\"submit\" ng-disabled=\"car.edit_form.$submitted\">{{car.dialog.type === \'add\' ? \'新增爱车\' : \'保存\'}}</button></td></tr></tbody></table></form><div ng-show=\"car.dialog.status === 1\" class=\"tc car-license\"><div class=\"car-license-img bc mt20\"></div><button type=\"button\" class=\"button-confirm button-normal mb10 mt20\" ng-click=\"car.dialog.status = 0\">返回</button></div></div></div><div dialog=\"\" modal=\"\" ng-if=\"car.dialogRemoveCar.open\" close=\"car.dialogRemoveCar.open=false\"><div dialog-title=\"\">删除车辆</div><div dialog-content=\"\" style=\"min-width: 300px;\"><p>您确定要删除该车辆吗?</p><p class=\"col-light mt15\">{{car.dialogRemoveCar.content | carModelFilter}}</p><div class=\"mt20 tr\"><button class=\"button\" ng-click=\"car.dialogRemoveCar.open=false\">取消</button>&nbsp; <button class=\"button-confirm\" ng-click=\"car.dialogRemoveCar.ok()\" ng-disabled=\"car.dialogRemoveCar.$submitted\">确定</button></div></div></div>");
$templateCache.put("app/views/profile/nickname/nickname.html","<h2 class=\"title\">设置昵称</h2><p class=\"mt20 col-light\">昵称用于展示，<span class=\"col-warn\">填写后不可修改</span></p><form class=\"pr mt10\" style=\"width:50%\" name=\"nickname.nickname_form\" ng-submit=\"nickname.updateNickname(nickname.nickname_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><input type=\"text\" class=\"form-control\" placeholder=\"最长7个汉字，或14个字节（半角数字、字母、下划线）\" name=\"nickname\" ng-model=\"nickname.nickname\" ng-pattern=\"/^[\\w|\\u4e00-\\u9fa5]+$/\" required=\"\" autofocus=\"\"><div as-messages=\"nickname\"><div as-message=\"required\">请输入昵称</div><div as-message=\"pattern\">最长7个汉字，或14个字节（半角数字、字母、下划线）</div></div><button type=\"submit\" class=\"button button-normal button-confirm mt30\" ng-disabled=\"nickname.nickname_form.$submitted\">保存</button></form>");
$templateCache.put("app/views/profile/photo/photo.html","<h2 class=\"title\">我的头像</h2><div class=\"mt30\"><button class=\"button button-confirm button-normal\" ng-click=\"photo.pickPhoto()\">上传头像</button> <span class=\"col-light ml15\">仅支持jpg、jpeg、gif、png、bmp格式的图片</span></div><div class=\"mt30 cf\"><div class=\"photo-review1 fl\" ng-show=\"!photo.file\"><img mg-photo=\"\" class=\"photo-reviewImg\" ng-src=\"{{photo.photo}}\"></div><div class=\"photoContent fl pr\" ng-show=\"photo.file\" style=\"width: 350px;\"><div id=\"canvasOverlay\"><i class=\"canvasOverlay-tl\" role=\"tl\"></i> <i class=\"canvasOverlay-tr\" role=\"tr\"></i> <i class=\"canvasOverlay-br\" role=\"br\"></i> <i class=\"canvasOverlay-bl\" role=\"bl\"></i></div><div id=\"canvasContent\" class=\"pr fl\"><ul><li id=\"maskN\" class=\"canvasMask\"></li><li id=\"maskS\" class=\"canvasMask\"></li><li id=\"maskW\" class=\"canvasMask\"></li><li id=\"maskE\" class=\"canvasMask\"></li></ul></div></div><div class=\"fl tc photo-review-small\"><h3>头像预览</h3><div class=\"photo-review2 bc mt20\"><img mg-photo=\"\" class=\"photo-reviewImg\" ng-src=\"{{photo.photo}}\"></div><p>小头像60*60</p><div class=\"photo-review3 bc mt20\"><img mg-photo=\"\" class=\"photo-reviewImg\" ng-src=\"{{photo.photo}}\"></div><p>大头像100*100</p></div></div><div class=\"mt30\"><button class=\"button button-confirm button-normal\" ng-click=\"photo.upLoadPhoto()\" ng-disabled=\"!photo.file || photo.submitted\">保存</button> <button class=\"button button-normal ml30\" ng-click=\"photo.cleanPhoto()\" ng-disabled=\"!photo.file || photo.submitted\">取消</button></div>");
$templateCache.put("app/views/redirect/activateEmail/activateEmail.html","<div ng-if=\"activateEmail.failed\" class=\"tc\"><p class=\"col-error\" style=\"padding-top: 160px; font-size: 20px;\">激活失败{{activateEmail.message}}</p><button class=\"button button-normal mt40\" ui-sref=\"noAccess.login({redirect:redirectUrl})\">返回登录页</button></div>");
$templateCache.put("app/views/redirect/weixinBind/weixinBind.html","<div ng-if=\"weixinBind.error\" class=\"tc\"><p class=\"col-error\" style=\"padding-top: 160px; font-size: 20px;\" ng-bind=\"weixinBind.error\"></p><div mg-close-window-button=\"关闭\" cd=\"10\"></div></div><div ng-if=\"weixinBind.success\" class=\"tc\"><p class=\"col-success\" style=\"padding-top: 160px; font-size: 20px;\" ng-bind=\"weixinBind.success\"></p><div mg-close-window-button=\"关闭\" cd=\"10\"></div></div>");
$templateCache.put("app/views/redirect/weixinLogin/weixinLogin.html","<div ng-if=\"weixinLogin.error\" class=\"tc\"><p class=\"col-error\" style=\"padding-top: 160px; font-size: 20px;\" ng-bind=\"weixinLogin.error\"></p><div mg-close-window-button=\"关闭\" cd=\"10\"></div></div>");
$templateCache.put("app/views/security/bindEmail/bindEmail.html","<h2 class=\"title\">绑定邮箱</h2><p class=\"mt30\" ng-if=\"userInfo.email\"><span class=\"col-success\" style=\"font-size: 20px;\">{{userInfo.email | emailFilter}}</span> <a href=\"javascript:;\" class=\"ml10\" ng-click=\"bindEmail.openChange()\">[修改]</a></p><p class=\"mt30\" ng-if=\"!userInfo.email\"><span>您还没有绑定邮箱</span> <a href=\"javascript:;\" class=\"ml10\" ng-click=\"bindEmail.openBind()\">[立即绑定]</a></p><p class=\"col-light\">绑定邮箱可用于登录WeCloud账号和找回密码</p><div dialog=\"\" modal=\"\" ng-if=\"bindEmail.dialog.open\" close=\"bindEmail.dialog.open = false\"><div dialog-title=\"\">{{bindEmail.params.type === \'bind\' ? \'绑定邮箱\' : \'修改绑定邮箱\'}}</div><div class=\"mt10\" dialog-content=\"\" style=\"min-width: 420px;\"><form class=\"form\" ng-if=\"bindEmail.params.type === \'changeBind\' && bindEmail.dialog.view === 0\" name=\"bindEmail.change_form\" ng-submit=\"bindEmail.dialog.next(bindEmail.change_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table style=\"width: 96%\"><tbody><tr><td class=\"form-label\">邮箱</td><td colspan=\"2\" mg-input=\"bindEmail.params.oldEmail\"><input class=\"form-control\" type=\"text\" placeholder=\"当前绑定的邮箱\" name=\"oldEmail\" ng-model=\"bindEmail.params.oldEmail\" ng-pattern=\"/^([a-z0-9]+([._\\\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+)$/i\" required=\"\" autofocus=\"\"><div as-messages=\"oldEmail\"><div as-message=\"required\">请输入邮箱</div><div as-message=\"pattern\">邮箱格式不正确</div></div></td></tr><tr><td class=\"form-label\" style=\"width: 60px;\">验证码</td><td><input class=\"form-control\" type=\"text\" placeholder=\"邮件验证码\" name=\"oldVcode\" ng-model=\"bindEmail.params.oldVcode\" ng-pattern=\"/^\\w{4,8}$/\" required=\"\"></td><td style=\"width: 100px; padding-left: 10px;\"><button class=\"button button-long\" type=\"button\" mg-vcode-button=\"bindEmail.changeBindVcodeOptions\">获取验证码</button><div as-messages=\"oldVcode\"><div as-message=\"pattern\">请输入邮件验证码</div><div as-message=\"required\">邮件验证码不正确</div></div></td></tr><tr><td class=\"form-label\"></td><td colspan=\"2\"><button class=\"button-confirm button-long\" type=\"submit\" ng-disabled=\"bindEmail.change_form.$submitted\">下一步</button></td></tr></tbody></table></form><form class=\"form\" ng-if=\"(bindEmail.params.type === \'changeBind\' && bindEmail.dialog.view === 1) || bindEmail.params.type === \'bind\'\" name=\"bindEmail.bind_form\" ng-submit=\"bindEmail.dialog.bind(bindEmail.bind_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table style=\"width: 96%\"><tbody><tr><td class=\"form-label\">邮箱</td><td colspan=\"2\" mg-input=\"bindEmail.params.newEmail\"><input class=\"form-control\" type=\"text\" placeholder=\"{{bindEmail.params.type === \'bind\' ? \'邮箱\' : \'要绑定的新邮箱\'}}\" ng-blur=\"bindEmail.vacant()\" name=\"newEmail\" ng-model=\"bindEmail.params.newEmail\" ng-pattern=\"/^([a-z0-9]+([._\\\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+)$/i\" required=\"\" autofocus=\"\"><div as-messages=\"newEmail\"><div as-message=\"required\">请输入邮箱</div><div as-message=\"pattern\">邮箱格式不正确</div></div></td></tr><tr><td class=\"form-label\" style=\"width: 60px;\">验证码</td><td><input class=\"form-control\" type=\"text\" placeholder=\"邮件验证码\" name=\"newVcode\" ng-model=\"bindEmail.params.newVcode\" ng-pattern=\"/^\\w{4,8}$/\" required=\"\"></td><td style=\"width: 100px; padding-left: 10px;\"><button class=\"button button-long\" type=\"button\" mg-vcode-button=\"bindEmail.bindVcodeOptions\">获取验证码</button><div as-messages=\"newVcode\"><div as-message=\"required\">请输入邮件验证码</div><div as-message=\"pattern\">邮件验证码不正确</div></div></td></tr><tr><td class=\"form-label\"></td><td colspan=\"2\"><button class=\"button-confirm button-long\" type=\"submit\" ng-disabled=\"bindEmail.bind_form.$submitted\">绑定</button></td></tr></tbody></table></form></div></div>");
$templateCache.put("app/views/security/bindMobile/bindMobile.html","<h2 class=\"title\">绑定手机</h2><p class=\"mt30\" ng-if=\"userInfo.mobile\"><span class=\"col-success\" style=\"font-size: 20px;\">{{userInfo.mobile | mobileFilter}}</span> <a href=\"javascript:;\" class=\"ml10\" ng-click=\"bindMobile.openChange()\">[修改]</a></p><p class=\"mt30\" ng-if=\"!userInfo.mobile\"><span>您还没有绑定手机</span> <a href=\"javascript:;\" class=\"ml10\" ng-click=\"bindMobile.openBind()\">[立即绑定]</a></p><p class=\"col-light\">绑定手机可用于登录WeCloud账号和找回密码</p><div dialog=\"\" modal=\"\" ng-if=\"bindMobile.dialog.open\" close=\"bindMobile.dialog.open = false\"><div dialog-title=\"\">{{bindMobile.params.type === \'bind\' ? \'绑定手机\' : \'修改绑定手机\'}}</div><div class=\"mt10\" dialog-content=\"\" style=\"min-width: 420px;\"><form class=\"form\" ng-if=\"bindMobile.params.type === \'changeBind\' && bindMobile.dialog.view === 0\" name=\"bindMobile.change_form\" ng-submit=\"bindMobile.dialog.next(bindMobile.change_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table style=\"width: 96%\"><tbody><tr><td class=\"form-label\">手机</td><td colspan=\"2\" mg-input=\"bindMobile.params.oldMobile\"><input class=\"form-control\" type=\"text\" placeholder=\"当前绑定的手机\" name=\"oldMobile\" ng-model=\"bindMobile.params.oldMobile\" ng-pattern=\"/^1\\d{10}$/\" required=\"\" autofocus=\"\"><div as-messages=\"oldMobile\"><div as-message=\"required\">请输入手机</div><div as-message=\"pattern\">手机格式不正确</div></div></td></tr><tr><td class=\"form-label\" style=\"width: 60px;\">验证码</td><td><input class=\"form-control\" type=\"text\" placeholder=\"短信验证码\" name=\"oldSmsCode\" ng-model=\"bindMobile.params.oldSmsCode\" ng-pattern=\"/^\\w{4,8}$/\" required=\"\"></td><td style=\"width: 100px; padding-left: 10px;\"><button class=\"button button-long\" type=\"button\" mg-vcode-button=\"bindMobile.changeBindSmsOptions\">获取验证码</button><div as-messages=\"oldSmsCode\"><div as-message=\"required\">请输入短信验证码</div><div as-message=\"pattern\">短信验证码不正确</div></div></td></tr><tr><td class=\"form-label\"></td><td colspan=\"2\"><button class=\"button-confirm button-long\" type=\"submit\" ng-disabled=\"bindMobile.change_form.$submitted\">下一步</button></td></tr></tbody></table></form><form class=\"form\" ng-if=\"(bindMobile.params.type === \'changeBind\' && bindMobile.dialog.view === 1) || bindMobile.params.type === \'bind\'\" name=\"bindMobile.bind_form\" ng-submit=\"bindMobile.dialog.bind(bindMobile.bind_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table style=\"width: 96%\"><tbody><tr><td class=\"form-label\">手机</td><td colspan=\"2\" mg-input=\"bindMobile.params.newMobile\"><input class=\"form-control\" type=\"text\" placeholder=\"{{bindMobile.params.type === \'bind\' ? \'手机\' : \'要绑定的新手机\'}}\" ng-blur=\"bindMobile.vacant()\" name=\"newMobile\" ng-model=\"bindMobile.params.newMobile\" ng-pattern=\"/^1\\d{10}$/\" required=\"\" autofocus=\"\"><div as-messages=\"newMobile\"><div as-message=\"required\">请输入手机</div><div as-message=\"pattern\">手机格式不正确</div></div></td></tr><tr><td class=\"form-label\" style=\"width: 60px;\">验证码</td><td><input class=\"form-control\" type=\"text\" placeholder=\"短信验证码\" name=\"newSmsCode\" ng-model=\"bindMobile.params.newSmsCode\" ng-pattern=\"/^\\w{4,8}$/\" required=\"\"></td><td style=\"width: 100px; padding-left: 10px;\"><button class=\"button button-long\" type=\"button\" mg-vcode-button=\"bindMobile.bindSmsOptions\">获取验证码</button><div as-messages=\"newSmsCode\"><div as-message=\"required\">请输入短信验证码</div><div as-message=\"pattern\">短信验证码不正确</div></div></td></tr><tr><td class=\"form-label\"></td><td colspan=\"2\"><button class=\"button-confirm button-long\" type=\"submit\" ng-disabled=\"bindMobile.bind_form.$submitted\">绑定</button></td></tr></tbody></table></form></div></div>");
$templateCache.put("app/views/security/bindThirdParty/bindThirdParty.html","<h2 class=\"title\">账号关联</h2><p class=\"mt30 col-light\">您可以使用已关联的第三方帐号来登录本WeCloud帐号</p><div class=\"bindThirdParty-row\"><i></i> <span class=\"ml10 col-light\">微信</span><p ng-if=\"bindThirdParty.bindInfo.weixin\"><span class=\"col-success ml10\">已关联</span> <a class=\"ml10\" href=\"javascript:;\" ng-click=\"bindThirdParty.unBind(\'weixin\')\">[解除关联]</a></p><p ng-if=\"!bindThirdParty.bindInfo.weixin\"><span class=\"col-warn ml10\">未关联</span> <a class=\"ml10\" href=\"javascript:;\" ng-click=\"bindThirdParty.openBindQRCode()\">[立即关联]</a></p></div>");
$templateCache.put("app/views/security/updatePassword/updatePassword.html","<h2 class=\"title\">修改密码</h2><p class=\"col-light mt20\" style=\"max-width: 490px;\">如果忘记或未设置过登录密码，请点击 <a href=\"javascript:;\" ui-sref=\"noAccess.findPassword({redirect:redirectUrl})\">忘记密码</a> 通过已绑定的手机或者邮箱验证并设置新密码。</p><form class=\"form mt30\" style=\"max-width: 380px;\" name=\"updatePassword.updatePW_form\" ng-submit=\"updatePassword.updatePassword(updatePassword.updatePW_form.$valid);\" autocomplete=\"off\" novalidate=\"\"><table><tbody><tr><td class=\"form-label\" style=\"width: 60px;\">当前密码</td><td mg-input=\"updatePassword.params.oldPassword\"><input class=\"form-control\" type=\"password\" placeholder=\"当前密码\" name=\"oldPassword\" ng-model=\"updatePassword.params.oldPassword\" ng-pattern=\"{{pattern.password}}\" required=\"\" autofocus=\"\"><div as-messages=\"oldPassword\"><div as-message=\"required\">请输入当前密码</div><div as-message=\"pattern\">密码错误</div></div></td></tr><tr><td class=\"form-label\">新密码</td><td mg-input=\"updatePassword.params.newPassword\"><input class=\"form-control\" type=\"password\" placeholder=\"6~20位，建议数字、字母、符号组合\" name=\"newPassword\" ng-model=\"updatePassword.params.newPassword\" ng-pattern=\"{{pattern.password}}\" required=\"\"><div as-messages=\"newPassword\"><div as-message=\"required\">请输入新密码</div><div as-message=\"pattern\">请输入6-20位半角字符，建议数字、字母、符号组合</div></div></td></tr><tr><td class=\"form-label\"></td><td colspan=\"2\"><button class=\"button-confirm button-long\" ng-disabled=\"updatePassword.updatePW_form.$submitted\">确定</button></td></tr></tbody></table></form>");}]);